// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T18:10:22.562Z
// Property: Cypress Pointe (ID: 6767906449167196)
// Collections: 19 amenities, 6 floorplans (live), 21 photos, 76 POIs, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167196",
  "property_external_id": "1089884",
  "property_zillow_url": "https://www.zillow.com/apartments/midland-tx/cypress-pointe/5XhxTh/",
  "property_apartments_url": "https://www.apartments.com/cypress-pointe-midland-tx/gjdz58y/",
  "property_google_business_url": "https://www.google.com/maps/place/Cypress+Pointe/data=!4m2!3m1!1s0x0:0x42b3b5a589d89838?sa=X&ved=2ahUKEwiK5ZrP94OTAxWRrIkEHZ8JEVgQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47569576752",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cypress-pointe",
  "property_name": "Cypress Pointe",
  "property_website_url": "https://texas.weidner.com/apartments/tx/midland/cypress-pointe-4/index.aspx",
  "property_domain": "https://www.cypresspointeapartmenthomes.com",
  "property_address": "3601 Andrews Hwy",
  "property_full_address": "3601 Andrews Hwy, Midland, TX 79703",
  "property_address_1": "3601 Andrews Hwy",
  "property_address_2": null,
  "property_address_city": "Midland",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79703",
  "property_address_country": "US",
  "property_address_county": "Midland County",
  "property_neighborhood_address": "Superior",
  "property_address_latitude": "32.0022256",
  "property_address_longitude": "-102.1311573",
  "property_email": "cypresspointe@weidner.com",
  "property_phone": "4325476149",
  "property_call_tracking_phone": "432-218-3263",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Cypress Pointe in Midland, TX, where comfort meets style. Choose from spacious studio, one, or two-bedroom floor plans, each featuring modern amenities like vaulted ceilings, walk-in closets, and wood-burning fireplaces. Dive into our outdoor pool, relax in the courtyard, or let your kids enjoy the playground. Find your new home today!",
  "property_long_description": "**Welcome to Cypress Pointe – Your Ideal Home in Midland, TX!** \n\nDiscover the perfect blend of comfort and style at Cypress Pointe, where we offer an array of thoughtfully designed floor plans including studios, one-bedroom, and two-bedroom apartments to suit your lifestyle. Each apartment features modern conveniences such as central AC and heating, allowing you to enjoy year-round comfort. Select homes even come with added luxuries like vaulted ceilings, ceiling fans, wood-burning fireplaces, and private patios or balconies—perfect for unwinding after a long day.\n\nAt Cypress Pointe, we prioritize your comfort and peace of mind. Our dedicated management and maintenance teams are on-site to ensure prompt assistance, while our emergency maintenance staff is available around the clock to address any urgent needs. Families will love the outdoor playground, and everyone can take advantage of the inviting courtyard and sparkling outdoor pool, providing a perfect backdrop for relaxation and recreation.\n\nAdd to that the convenience of washer/dryer hookups in select two-bedroom homes, built-in bookshelves, and spacious dining areas, and you’ll see why Cypress Pointe is the ideal place to call home. With walk-in closets in every apartment, you’ll have ample storage for all your belongings.\n\nDon’t wait any longer to experience all that Cypress Pointe has to offer! Find your new home today by browsing our availability or scheduling a tour to visit our vibrant community in Midland, TX. We can’t wait to welcome you!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-1b7a-7259-9a88-6585c42a6e84.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with fireplace, desk, and sofa.",
    "public_id": "019d0220-1b7a-7259-9a88-6585c42a6e84",
    "storage_key": "property/6767906449167196/019d0220-1b7a-7259-9a88-6585c42a6e84.webp",
    "width": 1600,
    "height": 900
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "189",
  "property_year_built": "1980",
  "property_year_renovated": null,
  "property_walk_score": "53",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.17989417989418",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Deposit: $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/cypress-pointe-4/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafenet.com/residentservices/cypress-pointe-4/userlogin",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/cypress-pointe-4/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a1413c-bcbb-71ba-9e03-0f0a97647fb7.webp",
  "property_primary_logo_media": {
    "alt_text": "Cypress Pointe Apartment Homes logo",
    "public_id": "01a1413c-bcbb-71ba-9e03-0f0a97647fb7",
    "storage_key": "property/6767906449167196/01a1413c-bcbb-71ba-9e03-0f0a97647fb7.webp",
    "width": 173,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a1413c-eb0a-762a-85fc-69785bbccbaa.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a1413c-eb0a-762a-85fc-69785bbccbaa",
    "storage_key": "property/6767906449167196/01a1413c-eb0a-762a-85fc-69785bbccbaa.webp",
    "width": 173,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a1413c-e20d-7293-913d-8b9a14414507.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a1413c-e20d-7293-913d-8b9a14414507",
    "storage_key": "property/6767906449167196/01a1413c-e20d-7293-913d-8b9a14414507.webp",
    "width": 173,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#50252D",
  "property_secondary_color": "#EDE4CE",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#9A6856",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "600 - 1100",
  "property_sqft_min": "600",
  "property_sqft_max": "1100",
  "property_price_range": "1005 - 1540",
  "property_price_min": "1005",
  "property_price_max": "1540",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/CypressPointeApartmentHomes",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJOa4avwjZ-4YROJjYiaW1s0I",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cypress Pointe",
  "property_home_romance_title": "Find Comfort and Community in Your Perfect New Apartment",
  "property_home_amenities_blurb": "Welcome to Cypress Pointe in Midland, TX, where comfort meets style. Choose from spacious studio, one, and two-bedroom layouts tailored to your lifestyle. Enjoy sunny days by the outdoor pool, unwind in our cozy courtyard, or let the kids play in the playground. Your dream home awaits!",
  "property_home_floorplans_blurb": "Welcome to Cypress Pointe in Midland, TX, where modern living meets comfort. With a variety of thoughtfully designed floor plans, each apartment home is a sanctuary tailored to your lifestyle. Take a moment to browse our available residences and uncover the perfect space that reflects your unique taste and needs.",
  "property_home_gallery_blurb": "At Cypress Pointe in Midland, TX, your dream home awaits. Choose from thoughtfully designed studio, one, or two-bedroom floor plans, each featuring modern amenities like spacious walk-in closets, cozy wood-burning fireplaces, and tranquil patios or balconies. With an outdoor pool, vibrant courtyard, and 24/7 emergency maintenance, picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Cypress Pointe in Midland, TX—a vibrant community where convenience meets comfort! With spacious studio, one, and two-bedroom floor plans, you’ll feel right at home. Embrace the energy of nearby attractions like Midland College, the Permian Basin Petroleum Museum, and Urban Air Trampoline Park. Uncover local favorites today!",
  "property_home_reviews_blurb": "At Cypress Pointe in Midland, TX, residents rave about the vibrant community atmosphere, saying, \"The staff is attentive and the amenities are fantastic!\" Join a neighborhood where comfort meets convenience. See what our residents have to say about living at our community—your next home awaits!",
  "property_neighborhood_blurb": "Welcome to Cypress Pointe in Midland, TX, where vibrant community life meets local treasures. Enjoy nearby parks like Summit Center Park and Beal Park for outdoor adventures, explore the intriguing Permian Basin Petroleum Museum, or catch a game at Astound Broadband Stadium. Your new home is the heart of it all!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cypress Pointe in Midland, TX, our thoughtfully designed studio, one, and two-bedroom apartments feature inviting layouts with vaulted ceilings, walk-in closets, and cozy fireplaces. Enjoy a vibrant lifestyle with amenities like a refreshing outdoor pool, playground, and on-site management. Your ideal home awaits!",
  "property_applynow_blurb": "At Cypress Pointe in Midland, TX, your ideal living space awaits with versatile floor plans, from cozy studios to spacious two bedrooms. Indulge in exceptional amenities, including an outdoor pool, a welcoming courtyard, and on-site maintenance. Enjoy the comfort of central AC, walk-in closets, and unique touches. Lease online today!",
  "property_contactus_blurb": "At Cypress Pointe in Midland, TX, find your perfect fit with stylish studio, one, and two-bedroom floor plans designed for modern living. Luxurious amenities and a welcoming community await you. Have questions? Contact our leasing team today to learn more about your future home!",
  "property_faqs_blurb": "At Cypress Pointe in Midland, TX, we offer a variety of floor plans—from cozy studios to spacious two-bedroom apartments—designed to suit your lifestyle. Have questions? Our FAQs page is your go-to resource for insights about our vibrant community. Get the answers you need today!",
  "property_floorplans_blurb": "At Cypress Pointe in Midland, TX, every lifestyle finds a home. Choose from our thoughtfully designed studio, one-bedroom, and two-bedroom floor plans, each offering comfort and style. Uncover the ideal space that complements your unique rhythm—browse our available apartment homes today and envision your new beginning.",
  "property_gallery_blurb": "At Cypress Pointe in Midland, TX, your ideal home awaits, whether it's a cozy studio or a spacious two-bedroom. Enjoy resort-style amenities, from a shimmering outdoor pool to serene courtyards. Imagine evening breezes on your private patio or balcony—picture yourself living here! Experience comfort and style in every detail.",
  "property_interactivemap_blurb": "At Cypress Pointe in Midland, TX, your perfect home awaits with charming studio, one, and two-bedroom floor plans. Enjoy amenities like an inviting outdoor pool, lush courtyard, and playground. Our dedicated teams ensure comfort with 24/7 emergency maintenance. Use our interactive community map to find your ideal apartment today!",
  "property_pets_blurb": "Cypress Pointe in Midland, TX, embraces your furry family members with open arms! With a convenient pet policy allowing up to two pets, you can enjoy a vibrant community while your beloved companions frolic in comfort. Unleash memorable moments in a home that truly welcomes pets!",
  "property_referafriend_blurb": "At Cypress Pointe in Midland, TX, your ideal living space awaits! Choose from stylish studio, one-bedroom, and two-bedroom floor plans designed for comfort and convenience. Great friends make great neighbors – refer a friend to our vibrant community today and enjoy all that Cypress Pointe has to offer!",
  "property_residentaccess_blurb": "Welcome to Cypress Pointe in Midland, TX, where comfort meets convenience. Whether you choose a cozy studio, a spacious one-bedroom, or a delightful two-bedroom apartment, you’ll find the perfect layout for your lifestyle. Access your resident portal now to effortlessly manage rent payments and maintenance requests!",
  "property_reviews_blurb": "At Cypress Pointe in Midland, TX, residents rave about the vibrant community atmosphere, stating it feels like \"a home away from home.\" Experience the warmth and camaraderie that make our apartments special. See what our residents have to say about living at our community and join the Cypress Pointe family today!",
  "property_created_at": "1771538556094",
  "property_scheduletour_blurb": "At Cypress Pointe in Midland, TX, find your perfect home with thoughtful studio, one-bedroom, and two-bedroom floor plans. Each space is designed for comfort and style. Curious about life here? Schedule a tour today and hear from our residents about their vibrant community experience!",
  "property_thankyou_blurb": "Thank you for reaching out to Cypress Pointe in Midland, TX! With a variety of thoughtfully designed floor plans, including studio, one-bedroom, and two-bedroom options, we cater to your unique lifestyle needs. A team member will connect with you soon—your perfect home awaits!",
  "property_virtualtours_blurb": "At Cypress Pointe in Midland, TX, our thoughtfully designed studio, one-bedroom, and two-bedroom apartments offer both comfort and style. Immerse yourself in our vibrant community—take a virtual tour today and envision your new home in a space that truly reflects your lifestyle!",
  "property_copyright": "2026 All Rights Reserved. Cypress Pointe",
  "property_seo_title_home": "Apartments for Rent - Cypress Pointe - Midland, TX",
  "property_seo_description_home": "Find pet-friendly apartments at Cypress Pointe in Midland, TX, with pool, playground, and fireplace options. Explore floor plans today.",
  "property_seo_title_floorplans": "Floor Plans - Cypress Pointe Apartments - Midland, TX",
  "property_seo_description_floorplans": "Browse studio, one, and two bedroom floor plans with walk-in closets, central AC, and flexible layouts at Cypress Pointe in Midland, TX.",
  "property_seo_title_amenities": "Amenities - Cypress Pointe Apartments - Midland, TX",
  "property_seo_description_amenities": "Enjoy an outdoor pool, playground, and in-home fireplace options at Cypress Pointe in Midland, TX. Explore all amenities today.",
  "property_seo_title_gallery": "Photo Gallery - Cypress Pointe Apartments - Midland, TX",
  "property_seo_description_gallery": "See the welcoming spaces, pool, and layouts at Cypress Pointe in Midland, TX. Explore photos and picture your new home.",
  "property_seo_title_virtualtours": "Cypress Pointe Apartments Virtual Tour - Midland, TX",
  "property_seo_description_virtualtours": "Explore Cypress Pointe Apartments virtually in Midland, TX. Tour the community online and imagine life in your new apartment home.",
  "property_seo_title_interactivemap": "Interactive Map | Cypress Pointe Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Cypress Pointe in Midland, TX! Explore our studio to two-bedroom apartments with amenities like a pool, playground, and more!",
  "property_seo_title_neighborhood": "Neighborhood - Cypress Pointe Apartments - Midland, TX",
  "property_seo_description_neighborhood": "Explore shops, parks, top employers, and entertainment near Cypress Pointe Apartments in Midland, TX. Discover your new neighborhood.",
  "property_seo_title_contact": "Contact Cypress Pointe Apartments - Midland, TX",
  "property_seo_description_contact": "Contact the team at Cypress Pointe Apartments in Midland, TX. Get details on availability and schedule a tour today.",
  "property_seo_title_faqs": "FAQs | Apartments in Midland, TX",
  "property_seo_description_faqs": "Unlock the secrets of Cypress Pointe in Midland, TX! Visit our FAQs to learn about our studios, amenities, and community life tailored just for you.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Midland, TX",
  "property_seo_description_reviews": "Experience life at Cypress Pointe in Midland, TX! Enjoy spacious floor plans, amazing amenities, and resident satisfaction. See what our community loves today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Midland, TX",
  "property_seo_description_applynow": "Discover comfort at Cypress Pointe, Midland, TX! Choose from stylish studios to spacious two-bedrooms with pools and courtyards. Apply online!",
  "property_seo_title_residentaccess": "Resident Access | Cypress Pointe",
  "property_seo_description_residentaccess": "Stay connected at Cypress Pointe in Midland, TX! Log in to your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Cypress Pointe",
  "property_seo_description_referafriend": "Refer a friend to Cypress Pointe in Midland, TX! Great friends make great neighbors—share the joy of our vibrant community with those you care about today!",
  "property_seo_title_scheduletour": "Schedule a Tour - Cypress Pointe Apartments - Midland, TX",
  "property_seo_description_scheduletour": "Schedule a guided or virtual tour at Cypress Pointe Apartments in Midland, TX. Discover your next home at your own pace.",
  "property_seo_title_privacy": "Privacy Policy | Cypress Pointe",
  "property_seo_description_privacy": "Your privacy matters at Cypress Pointe in Midland, TX. Learn how we protect your information while you enjoy your ideal apartment lifestyle. Read our policy.",
  "property_seo_title_accessibility": "Website Accessibility | Cypress Pointe",
  "property_seo_description_accessibility": "Experience seamless living at Cypress Pointe in Midland, TX. Our commitment to accessibility ensures everyone can enjoy our vibrant community. Join us!",
  "property_seo_title_sitemap": "Sitemap | Cypress Pointe",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Cypress Pointe in Midland, TX! Access our sitemap for a seamless tour of our vibrant community and all it offers.",
  "property_seo_title_thankyou": "Thank You | Cypress Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Cypress Pointe in Midland, TX! Our team will be in touch soon to help you find your perfect home. Stay tuned for updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Midland, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1792766420561",
  "amenities": [
    {
      "id": "ec_d02c0bcbbd909a1457d568a4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352951",
      "title": "Pool",
      "amount": "false",
      "description": "Open Seasonally 10am - 10pm",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d9a36-4835-739f-b9fa-7aee2ec8eb4c.webp",
      "amenity_image_media": {
        "alt_text": "A refreshing blue swimming pool with lounge chairs and umbrellas at a multifamily property.",
        "public_id": "019d9a36-4835-739f-b9fa-7aee2ec8eb4c",
        "storage_key": "property/6767906449167196/019d9a36-4835-739f-b9fa-7aee2ec8eb4c.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": ",",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6f0d9988a5de82715614185",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352950",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d9a36-46a1-77bb-928c-69f4d19cc577.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019d9a36-46a1-77bb-928c-69f4d19cc577",
        "storage_key": "property/6767906449167196/019d9a36-46a1-77bb-928c-69f4d19cc577.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21fdb948c4893da39aab0c1f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352948",
      "title": "Laundry Facilities/Laundry Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d9a36-46b1-7128-9f27-c3c651a40442.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with rows of washers and dryers",
        "public_id": "019d9a36-46b1-7128-9f27-c3c651a40442",
        "storage_key": "property/6767906449167196/019d9a36-46b1-7128-9f27-c3c651a40442.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb7b9ce4d306ab0ad513754d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87398113",
      "title": "Open Carport Parking",
      "amount": "false",
      "description": "First Come, First Serve",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1c183480565843ad00c82f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352949",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1b419d53ca0e72f92209cf2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87398101",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6469a25a4579c97a142471ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87398104",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a82e96adcfb9fff68f191b1e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87398102",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec9eb77a7b786e7c5e497ba0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "88164546",
      "title": "MISD & ECISD Teacher's Discount",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-7692-737c-b4bf-a5b45a058c2c.webp",
      "amenity_image_media": {
        "alt_text": "MISD and ECISD Teacher's Discount graphic",
        "public_id": "019d0220-7692-737c-b4bf-a5b45a058c2c",
        "storage_key": "property/6767906449167196/019d0220-7692-737c-b4bf-a5b45a058c2c.webp",
        "width": 2919,
        "height": 1712
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5314dcd0eadd286541ff4905",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "124799872",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72ae161b48a73e7fce949bdf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "125324355",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-744e-736b-9d7c-500884839c3e.webp",
      "amenity_image_media": {
        "alt_text": "Computer desk with printer and computer displaying Weidner Apartment Homes logo.",
        "public_id": "019d0220-744e-736b-9d7c-500884839c3e",
        "storage_key": "property/6767906449167196/019d0220-744e-736b-9d7c-500884839c3e.webp",
        "width": 481,
        "height": 640
      },
      "amenity_image_alt_text": "A computer with a blue screen is on a desk with a white chair.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4eda11ca756d07912fca804",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352956",
      "title": "Central AC and Heating in Every Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1061948811991d58b4abae19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352958",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68807408434571a9eae389c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352959",
      "title": "Wood-Burning Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d9a36-465a-7766-8109-cadd205c2477.webp",
      "amenity_image_media": {
        "alt_text": "Cozy apartment living room with a fireplace, desk, and seating.",
        "public_id": "019d9a36-465a-7766-8109-cadd205c2477",
        "storage_key": "property/6767906449167196/019d9a36-465a-7766-8109-cadd205c2477.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_daf1fc21d3dd85eeb43e3649",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352960",
      "title": "Patio/Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_967cf81e1a62f155340ff1dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352961",
      "title": "Vaulted Ceiling*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5934c3fd586151a6cbdd8258",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352964",
      "title": "Built-In Bookshelves*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_664f6e1dcb3c8ae038843b3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352965",
      "title": "Dining Area",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0666668866481be41be71d8d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "external_id": "87352967",
      "title": "Walk-In Closets in Every Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_251e26d29e00e19e2622fd35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-1b7a-7259-9a88-6585c42a6e84.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, desk, and sofa.",
        "public_id": "019d0220-1b7a-7259-9a88-6585c42a6e84",
        "storage_key": "property/6767906449167196/019d0220-1b7a-7259-9a88-6585c42a6e84.webp",
        "width": 1600,
        "height": 900
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, a functional desk area, and comfortable seating, perfect for relaxation and productivity.",
      "link": "false",
      "alt_text": "Living room with fireplace, desk, and sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (1).jpg"
    },
    {
      "id": "ec_3c2017ba29f283b7440413e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019fdada-9ae7-76dc-9081-ed93430c93e7.webp",
      "image_media": {
        "alt_text": "Up to one month free on select homes promotion. Equal Housing Opportunity.",
        "public_id": "019fdada-9ae7-76dc-9081-ed93430c93e7",
        "storage_key": "property/6767906449167196/019fdada-9ae7-76dc-9081-ed93430c93e7.webp",
        "width": 1084,
        "height": 684
      },
      "title": "Other",
      "description": "Limited time offer: Receive up to one month free on select homes. Specials, pricing, and availability are subject to change daily. Contact the leasing office for details. Equal Housing Opportunity.",
      "link": "false",
      "alt_text": "Up to one month free on select homes promotion. Equal Housing Opportunity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Specials(3).jpg"
    },
    {
      "id": "ec_fb1d86d5b1cae6356069debb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-1b71-70d5-b95c-3d3d0dd1b854.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, and kitchen bar.",
        "public_id": "019d0220-1b71-70d5-b95c-3d3d0dd1b854",
        "storage_key": "property/6767906449167196/019d0220-1b71-70d5-b95c-3d3d0dd1b854.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable sofa, and a breakfast bar connecting to the kitchen. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room with fireplace, sofa, and kitchen bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (2).JPG"
    },
    {
      "id": "ec_c8f1291654be24cf8132fa24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-1b7a-7259-9a88-6b56069251fc.webp",
      "image_media": {
        "alt_text": "Kitchen with a white refrigerator, double sink, dishwasher, and wooden cabinets.",
        "public_id": "019d0220-1b7a-7259-9a88-6b56069251fc",
        "storage_key": "property/6767906449167196/019d0220-1b7a-7259-9a88-6b56069251fc.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "A well-lit kitchen featuring a refrigerator, double sink with faucet, dishwasher, and ample cabinet space.",
      "link": "false",
      "alt_text": "Kitchen with a white refrigerator, double sink, dishwasher, and wooden cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (3).JPG"
    },
    {
      "id": "ec_4b7fdb0eb41722235dd9d492",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-25eb-7096-806c-8b00cc3e9cdb.webp",
      "image_media": {
        "alt_text": "Kitchen sink with fruit on counter",
        "public_id": "019d0220-25eb-7096-806c-8b00cc3e9cdb",
        "storage_key": "property/6767906449167196/019d0220-25eb-7096-806c-8b00cc3e9cdb.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Double stainless steel kitchen sink with a decorative bowl of fruit on the counter, and wooden cabinets above.",
      "link": "false",
      "alt_text": "Kitchen sink with fruit on counter",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (4).JPG"
    },
    {
      "id": "ec_4e6ac64baf86d924b5924977",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-2825-74ac-ab00-c4ecfdad4700.webp",
      "image_media": {
        "alt_text": "Dining area with a glass-top table and four chairs, and a glimpse into a bedroom.",
        "public_id": "019d0220-2825-74ac-ab00-c4ecfdad4700",
        "storage_key": "property/6767906449167196/019d0220-2825-74ac-ab00-c4ecfdad4700.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy a meal in this charming dining area, perfect for intimate gatherings. The adjacent bedroom offers a cozy retreat.",
      "link": "false",
      "alt_text": "Dining area with a glass-top table and four chairs, and a glimpse into a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (5).JPG"
    },
    {
      "id": "ec_df4cfdbacffe3abdeae0612a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-2627-732d-b4ab-e9cf582b424b.webp",
      "image_media": {
        "alt_text": "Desk and bar stools in apartment",
        "public_id": "019d0220-2627-732d-b4ab-e9cf582b424b",
        "storage_key": "property/6767906449167196/019d0220-2627-732d-b4ab-e9cf582b424b.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Create a productive workspace at the desk or enjoy a casual meal at the bar with these comfortable stools.",
      "link": "false",
      "alt_text": "Desk and bar stools in apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (6).JPG"
    },
    {
      "id": "ec_348d6885be3c3541d5b87db1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-261b-712d-a18e-860252e7a7df.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "019d0220-261b-712d-a18e-860252e7a7df",
        "storage_key": "property/6767906449167196/019d0220-261b-712d-a18e-860252e7a7df.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with plush bedding, a decorative nightstand with a lamp, and a window with vertical blinds.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (7).JPG"
    },
    {
      "id": "ec_974f79ebc93aa4d1bb922491",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-30a4-71ef-9e23-3e8e891706c8.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, mirror, and toilet.",
        "public_id": "019d0220-30a4-71ef-9e23-3e8e891706c8",
        "storage_key": "property/6767906449167196/019d0220-30a4-71ef-9e23-3e8e891706c8.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our well-appointed bathrooms. Featuring a spacious vanity, modern fixtures, and ample storage.",
      "link": "false",
      "alt_text": "Bathroom with vanity, sink, mirror, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (8).JPG"
    },
    {
      "id": "ec_a6aa752c84a51b23bbd95c87",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-3131-7031-b05c-4385dfd7d4a2.webp",
      "image_media": {
        "alt_text": "Interior view of apartment complex lounge area with pool view",
        "public_id": "019d0220-3131-7031-b05c-4385dfd7d4a2",
        "storage_key": "property/6767906449167196/019d0220-3131-7031-b05c-4385dfd7d4a2.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax in the lounge area with large windows overlooking the sparkling pool and courtyard. Enjoy comfortable seating and a stylish design.",
      "link": "false",
      "alt_text": "Interior view of apartment complex lounge area with pool view",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (9).JPG"
    },
    {
      "id": "ec_556d6e9b92ff873b2299e62a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-321c-757e-896a-8d5049ddfc48.webp",
      "image_media": {
        "alt_text": "Spacious living area with a breakfast bar, dining area, and decorative console table.",
        "public_id": "019d0220-321c-757e-896a-8d5049ddfc48",
        "storage_key": "property/6767906449167196/019d0220-321c-757e-896a-8d5049ddfc48.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space, perfect for entertaining, with a convenient breakfast bar and a separate dining area.",
      "link": "false",
      "alt_text": "Spacious living area with a breakfast bar, dining area, and decorative console table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (10).JPG"
    },
    {
      "id": "ec_abe1c7a7e143b9b3cb08d365",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-3220-7184-9d31-d05eab8bceb0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d0220-3220-7184-9d31-d05eab8bceb0",
        "storage_key": "property/6767906449167196/019d0220-3220-7184-9d31-d05eab8bceb0.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxation and fun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (11).JPG"
    },
    {
      "id": "ec_70959f534e87b08be818da35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-3996-76ac-870b-dc3a9295a9af.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "019d0220-3996-76ac-870b-dc3a9295a9af",
        "storage_key": "property/6767906449167196/019d0220-3996-76ac-870b-dc3a9295a9af.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. A perfect oasis for relaxation and fun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (12).JPG"
    },
    {
      "id": "ec_76b0009689391a3347852377",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-3b72-7553-99e3-3bac93b4e284.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019d0220-3b72-7553-99e3-3bac93b4e284",
        "storage_key": "property/6767906449167196/019d0220-3b72-7553-99e3-3bac93b4e284.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring vibrant slides and engaging play structures for children.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structures.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (13).JPG"
    },
    {
      "id": "ec_a90afa5ec616ac19bb6e67b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-3bec-739a-9eeb-4f1a3da46bc3.webp",
      "image_media": {
        "alt_text": "Playground area with slides and swings surrounded by green grass and trees, with apartment buildings in the background.",
        "public_id": "019d0220-3bec-739a-9eeb-4f1a3da46bc3",
        "storage_key": "property/6767906449167196/019d0220-3bec-739a-9eeb-4f1a3da46bc3.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for children to play and explore.",
      "link": "false",
      "alt_text": "Playground area with slides and swings surrounded by green grass and trees, with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (14).JPG"
    },
    {
      "id": "ec_2d399d8b318acbe5479d02f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-3c43-758f-96d4-be7d444bda12.webp",
      "image_media": {
        "alt_text": "Cypress Pointe Apartment Homes monument sign with balloons and landscaping.",
        "public_id": "019d0220-3c43-758f-96d4-be7d444bda12",
        "storage_key": "property/6767906449167196/019d0220-3c43-758f-96d4-be7d444bda12.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Cypress Pointe Apartment Homes! This monument sign is surrounded by lush landscaping and features festive balloons.",
      "link": "false",
      "alt_text": "Cypress Pointe Apartment Homes monument sign with balloons and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (15).jpg"
    },
    {
      "id": "ec_9c244abbff1e9b466fdf166f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-4463-748e-b0a5-f90e8c87da51.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs, a small table with a plant, and a view of trees and the sky.",
        "public_id": "019d0220-4463-748e-b0a5-f90e8c87da51",
        "storage_key": "property/6767906449167196/019d0220-4463-748e-b0a5-f90e8c87da51.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee on your private balcony, furnished with comfortable seating and overlooking scenic views.",
      "link": "false",
      "alt_text": "Balcony with two chairs, a small table with a plant, and a view of trees and the sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (16).JPG"
    },
    {
      "id": "ec_f6b9062c03db27d1d523ba6d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-4883-76b4-9975-670add7dcb78.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with outdoor staircases and manicured lawns.",
        "public_id": "019d0220-4883-76b4-9975-670add7dcb78",
        "storage_key": "property/6767906449167196/019d0220-4883-76b4-9975-670add7dcb78.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Discover comfortable living with our well-maintained apartment exteriors, featuring convenient outdoor staircases and beautiful green spaces.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with outdoor staircases and manicured lawns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (17).JPG"
    },
    {
      "id": "ec_45cab5e3260f8941b376cd41",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-4845-732f-a1a1-c45174f463d9.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a grassy lawn and trees.",
        "public_id": "019d0220-4845-732f-a1a1-c45174f463d9",
        "storage_key": "property/6767906449167196/019d0220-4845-732f-a1a1-c45174f463d9.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "This image shows the exterior of apartment buildings, featuring a well-maintained grassy area and mature trees, creating a pleasant community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with a grassy lawn and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (18).JPG"
    },
    {
      "id": "ec_72bbfa40791daaa52f8fdd0e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-517d-77c4-b607-f550246f2c34.webp",
      "image_media": {
        "alt_text": "Cypress Pointe property map signage",
        "public_id": "019d0220-517d-77c4-b607-f550246f2c34",
        "storage_key": "property/6767906449167196/019d0220-517d-77c4-b607-f550246f2c34.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to Cypress Pointe! View our community map for easy navigation of our grounds.",
      "link": "false",
      "alt_text": "Cypress Pointe property map signage",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (19).JPG"
    },
    {
      "id": "ec_0216b66457a3031832170f73",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-52a6-7208-860d-95a871d40acf.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with brick accents and green lawn.",
        "public_id": "019d0220-52a6-7208-860d-95a871d40acf",
        "storage_key": "property/6767906449167196/019d0220-52a6-7208-860d-95a871d40acf.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Exterior view of an apartment building featuring brick and stucco facade, surrounded by lush green grass and mature trees.",
      "link": "false",
      "alt_text": "Apartment building exterior with brick accents and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Cypress_Pointe_Favorites (20).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f3d96d52-206f-4ae7-9195-d8bd86449245",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Taco Villa",
      "poi_type": "Restaurants",
      "poi_address": "4411 Andrews Hwy, Midland, TX 79703, USA",
      "poi_short_description": "Local chain doling out familiar Mexican plates in a casual, kid-friendly space.",
      "poi_long_description": "Local chain doling out familiar Mexican plates in a casual, kid-friendly space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-1c59-746f-9f34-473f6d0e4e06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-1c59-746f-9f34-473f6d0e4e06",
        "storage_key": "property/6767906449167196/01a14138-1c59-746f-9f34-473f6d0e4e06.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://tacovilla.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1381458693303938276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taco-villa",
      "poi_latitude": "32.0010033",
      "poi_longitude": "-102.1383467",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 432-699-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0MJEAvZ-4YR5KxBvlztKxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d8541af4-f483-4df4-bfb1-d04daf380706",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Chinese Dumpling",
      "poi_type": "Restaurants",
      "poi_address": "4322 Andrews Hwy #B, Midland, TX 79703, USA",
      "poi_short_description": "Peaceful Chinese restaurant serving handmade dumplings and fresh noodle dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-225a-7572-a752-824104d09c3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-225a-7572-a752-824104d09c3a",
        "storage_key": "property/6767906449167196/01a14138-225a-7572-a752-824104d09c3a.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.chinesedumplingmidland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17861976105321697614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chinese-dumpling",
      "poi_latitude": "32.0025932",
      "poi_longitude": "-102.1359741",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 432-247-1686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw7M-UFDZ-4YRThE3iKF84vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_11076bfa-eda1-40e5-bf7e-bb0a7f55f1de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Jack 'N Jill Donuts",
      "poi_type": "Restaurants",
      "poi_address": "4324 Andrews Hwy # E, Midland, TX 79703, USA",
      "poi_short_description": "Local donut shop offering a variety of donuts and kolaches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-2298-712e-849c-3c8e10ddefa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-2298-712e-849c-3c8e10ddefa6",
        "storage_key": "property/6767906449167196/01a14138-2298-712e-849c-3c8e10ddefa6.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12862664452133703045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-n-jill-donuts",
      "poi_latitude": "32.0025093",
      "poi_longitude": "-102.1364278",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 432-247-1211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ4SYkgvZ-4YRhU15fitdgbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_8c16f8b0-80c3-4ba7-a414-97034cb5bbf5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "5120 Andrews Hwy, Midland, TX 79703, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-2689-718b-8ffc-3b3072a96592.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-2689-718b-8ffc-3b3072a96592",
        "storage_key": "property/6767906449167196/01a14138-2689-718b-8ffc-3b3072a96592.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/west-midland?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17585158674225463292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "31.9992713",
      "poi_longitude": "-102.1531764",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 432-699-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQ46yXnZ-4YR_H8W4KQIC_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d45aa90b-7ae5-4d26-8966-ecabe1745dae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Clear Springs Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5707 Andrews Hwy, Midland, TX 79706, USA",
      "poi_short_description": "Restaurant plating seafood, steaks & signature onion rings in a vibrant, barnlike setting.",
      "poi_long_description": "Restaurant plating seafood, steaks & signature onion rings in a vibrant, barnlike setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-1a2e-71ed-86e5-e5eba07f3245.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-1a2e-71ed-86e5-e5eba07f3245",
        "storage_key": "property/6767906449167196/01a14138-1a2e-71ed-86e5-e5eba07f3245.webp",
        "width": 1280,
        "height": 517
      },
      "poi_business_url": "http://clearspringsrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=623302863703208965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-springs-restaurant",
      "poi_latitude": "31.9956672",
      "poi_longitude": "-102.1583984",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-522-1188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr_axWX_Z-4YRBXSD8qZqpgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_64fab515-3a71-458d-baf4-dfba13993b30",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Hacienda Vieja",
      "poi_type": "Restaurants",
      "poi_address": "515 Andrews Hwy, Midland, TX 79701, USA",
      "poi_short_description": "Relaxed cantina with a dark wood interior serving traditional Mexican dishes & margaritas.",
      "poi_long_description": "Relaxed cantina with a dark wood interior serving traditional Mexican dishes & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-1f74-7287-947c-ed9849c74e64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-1f74-7287-947c-ed9849c74e64",
        "storage_key": "property/6767906449167196/01a14138-1f74-7287-947c-ed9849c74e64.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.haciendaviejausa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6816928166256238736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hacienda-vieja",
      "poi_latitude": "31.9973684",
      "poi_longitude": "-102.1057834",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-262-2458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJszUe0VnY-4YRkOAOsQyYml4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_71ddb5db-2867-40cb-bd99-c184af07ed0f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Don Tomás Café",
      "poi_type": "Restaurants",
      "poi_address": "3415 N Loop 250 W Ste 201, Midland, TX 79707, USA",
      "poi_short_description": "Casual Mexican eatery serving authentic breakfast burritos and homemade tortillas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-1f9b-755f-b652-82fee3ca7b15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-1f9b-755f-b652-82fee3ca7b15",
        "storage_key": "property/6767906449167196/01a14138-1f9b-755f-b652-82fee3ca7b15.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.dontomascafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9423726434215020590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "don-toms-caf",
      "poi_latitude": "32.0158102",
      "poi_longitude": "-102.1600728",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-704-5177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdVOi-2DZ-4YRLkjYS0PNx4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f4cea9fb-84b1-40b3-8139-c0b53cbd1e61",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Great Wall",
      "poi_type": "Restaurants",
      "poi_address": "2215 Midland Dr, Midland, TX 79707, USA",
      "poi_short_description": "Strip-mall stop offering classic Chinese dishes off the menu or lunch buffet, plus delivery options.",
      "poi_long_description": "Strip-mall stop offering classic Chinese dishes off the menu or lunch buffet, plus delivery options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-25ca-760d-aabf-9a44572f0431.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-25ca-760d-aabf-9a44572f0431",
        "storage_key": "property/6767906449167196/01a14138-25ca-760d-aabf-9a44572f0431.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4764596982612457803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-wall",
      "poi_latitude": "32.0082559",
      "poi_longitude": "-102.1399034",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 432-694-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6IwVA3Z-4YRS3mDNrY_H0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_4b93c0b1-09cc-44fe-9c5f-56e995f85e2d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Opal's Table",
      "poi_type": "Restaurants",
      "poi_address": "223 W Wall St, Midland, TX 79701, USA",
      "poi_short_description": "Stylish, airy eatery serving elevated & seasonal Southern cuisine plus craft cocktails & wine.",
      "poi_long_description": "Stylish, airy eatery serving elevated & seasonal Southern cuisine plus craft cocktails & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-1d2a-75af-9013-661ac0ea5d1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-1d2a-75af-9013-661ac0ea5d1f",
        "storage_key": "property/6767906449167196/01a14138-1d2a-75af-9013-661ac0ea5d1f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opalstable.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7113082365336465979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "opals-table",
      "poi_latitude": "31.9971056",
      "poi_longitude": "-102.0766361",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-687-1158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsVymT3nY-4YRO7L5e7m-tmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_e8b6a071-eea5-48a5-b9b2-676b6d74d4fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Wall Street Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "115 E Wall St, Midland, TX 79701, USA",
      "poi_short_description": "Contemporary American fare served in a 1910 building with pressed-tin ceilings & a mahogany bar.",
      "poi_long_description": "Contemporary American fare served in a 1910 building with pressed-tin ceilings & a mahogany bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-29a3-76fd-8d6f-8c86d02a5961.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-29a3-76fd-8d6f-8c86d02a5961",
        "storage_key": "property/6767906449167196/01a14138-29a3-76fd-8d6f-8c86d02a5961.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://wallstgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12556959651591467817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wall-street-bar--grill",
      "poi_latitude": "31.9976539",
      "poi_longitude": "-102.0736312",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-684-8686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMXrJznjY-4YRKbMFBEZIQ64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_cc101d96-ef5d-4fe1-ae84-18cf891e095f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Venezia Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2101 W Wadley Ave Ste 20, Midland, TX 79705, USA",
      "poi_short_description": "Lavish Italian bistro with extensive wine list, indoor fountain, fireplace & shaded outdoor patio.",
      "poi_long_description": "Lavish Italian bistro with extensive wine list, indoor fountain, fireplace & shaded outdoor patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-2bf4-7738-8816-fb8c00453357.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-2bf4-7738-8816-fb8c00453357",
        "storage_key": "property/6767906449167196/01a14138-2bf4-7738-8816-fb8c00453357.webp",
        "width": 1240,
        "height": 698
      },
      "poi_business_url": "https://www.veneziamidland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=755690594664609884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "venezia-restaurant",
      "poi_latitude": "32.022867999999995",
      "poi_longitude": "-102.104938",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-687-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMc5oTN3Y-4YRXHgWj5fAfAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_1cc06e55-0926-45ba-8784-857fc261ead5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Hopdoddy Burger Bar",
      "poi_type": "Restaurants",
      "poi_address": "4400 Midland Dr #500, Midland, TX 79707, USA",
      "poi_short_description": "Modern outfit for gourmet burgers & nonbeef options, plus spiked milkshakes & creative cocktails.",
      "poi_long_description": "Modern outfit for gourmet burgers & nonbeef options, plus spiked milkshakes & creative cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-2e08-769b-92c8-f26e07b76995.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-2e08-769b-92c8-f26e07b76995",
        "storage_key": "property/6767906449167196/01a14138-2e08-769b-92c8-f26e07b76995.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.hopdoddy.com/locations/midland",
      "poi_directions_map_url": "https://maps.google.com/?cid=1926161056599132560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hopdoddy-burger-bar",
      "poi_latitude": "32.0277428",
      "poi_longitude": "-102.1441167",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-789-1855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeaVTQ0bZ-4YRkEnIlkYZuxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_e688b96b-9d79-49e9-8bc2-d5c7d1ed92e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Saltgrass Steak House",
      "poi_type": "Restaurants",
      "poi_address": "4511 W Loop 250 N, Midland, TX 79707, USA",
      "poi_short_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_long_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-37b0-7713-adb6-aa77b3777698.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-37b0-7713-adb6-aa77b3777698",
        "storage_key": "property/6767906449167196/01a14138-37b0-7713-adb6-aa77b3777698.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.saltgrass.com/location/saltgrass-midland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8247688013604934449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saltgrass-steak-house",
      "poi_latitude": "32.0261332",
      "poi_longitude": "-102.1468797",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-699-0476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee92-70aa-a13c-0197fedbdf5b",
        "storage_key": "property/6767906449167196/019d0220-ee92-70aa-a13c-0197fedbdf5b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA13VIkTZ-4YRMVMr3YysdXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_11c27dce-4fd5-4b47-baa7-5ca1f6ecc0f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "United Supermarkets",
      "poi_type": "Shopping & Retail",
      "poi_address": "1002 Andrews Hwy, Midland, TX 79701, USA",
      "poi_short_description": "Local grocery store featuring deli and bakery departments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-3068-721c-adcd-8cc268b7b775.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-3068-721c-adcd-8cc268b7b775",
        "storage_key": "property/6767906449167196/01a14138-3068-721c-adcd-8cc268b7b775.webp",
        "width": 601,
        "height": 401
      },
      "poi_business_url": "https://local.unitedsupermarkets.com/tx/midland/1002-andrews-hwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4159204130926892614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-supermarkets",
      "poi_latitude": "32.0013169",
      "poi_longitude": "-102.1115598",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-694-8841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f330-7322-81c0-aa32659cc4e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f330-7322-81c0-aa32659cc4e2",
        "storage_key": "property/6767906449167196/019d0220-f330-7322-81c0-aa32659cc4e2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPd41s_jY-4YRRhY85B52uDk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ecb3673a-f95c-47f5-be65-8632f692fb62",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "CVS Pharmacy y más",
      "poi_type": "Health and Wellness",
      "poi_address": "301 Andrews Hwy, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-318c-73c0-bb8d-c1c12e68f625.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-318c-73c0-bb8d-c1c12e68f625",
        "storage_key": "property/6767906449167196/01a14138-318c-73c0-bb8d-c1c12e68f625.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/midland-tx-pharmacies/301-andrews-highway-midland-tx-79701/storeid=4356?WT.mc_id=LS_GOOGLE_RX_4356",
      "poi_directions_map_url": "https://maps.google.com/?cid=14436787944897068786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy-y-ms",
      "poi_latitude": "31.9955328",
      "poi_longitude": "-102.1010456",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-685-3092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-250289bca231.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-250289bca231",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-250289bca231.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1bsV1nY-4YR8j47gSXGWcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_09c5dbb5-e743-4dfc-a4ac-f492b8d6ae6b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "215 Andrews Hwy, Midland, TX 79701, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-3d2a-7750-8b70-b096f7a3f45e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-3d2a-7750-8b70-b096f7a3f45e",
        "storage_key": "property/6767906449167196/01a14138-3d2a-7750-8b70-b096f7a3f45e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-215+andrews+hwy-midland-tx-79701/id=6122",
      "poi_directions_map_url": "https://maps.google.com/?cid=617075062542279091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "31.994369100000004",
      "poi_longitude": "-102.099992",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-682-8211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZhHCVzY-4YRs6GV_n9KkAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_337e7a36-d55a-4926-ad9d-8dadce25198a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Stripes",
      "poi_type": "Shopping & Retail",
      "poi_address": "4317 Andrews Hwy, Midland, TX 79703, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-310e-7732-8fc6-ba7a2b982500.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-310e-7732-8fc6-ba7a2b982500",
        "storage_key": "property/6767906449167196/01a14138-310e-7732-8fc6-ba7a2b982500.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/midland/4317-andrews-highway-42472?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10996569274748249213&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stripes",
      "poi_latitude": "32.0016646",
      "poi_longitude": "-102.1363398",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 432-697-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ee8f-705c-95e2-a836b4a350c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-ee8f-705c-95e2-a836b4a350c2",
        "storage_key": "property/6767906449167196/019d0220-ee8f-705c-95e2-a836b4a350c2.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ1Q8puQvZ-4YRfSRYOX6pm5g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_26d1834b-535e-498d-b959-dcf74acfeb31",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Sunoco",
      "poi_type": "Transportation & Transit",
      "poi_address": "4324 Andrews Hwy, Midland, TX 79703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-36ee-700e-986c-46a0d5f678df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-36ee-700e-986c-46a0d5f678df",
        "storage_key": "property/6767906449167196/01a14138-36ee-700e-986c-46a0d5f678df.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.sunoco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3424977563777404133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunoco",
      "poi_latitude": "32.002266999999996",
      "poi_longitude": "-102.136651",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 432-697-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-894e-74f3-aace-263ea0ef9abb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-894e-74f3-aace-263ea0ef9abb",
        "storage_key": "property/6767906449167196/01a14138-894e-74f3-aace-263ea0ef9abb.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ01YnkQvZ-4YR5YyirPL2hy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_d15ce3e4-c06a-4eb5-8983-2957fa00e071",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "5407 Andrews Hwy, Midland, TX 79706, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-a05d-7663-94b9-5a69e3b99cf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-a05d-7663-94b9-5a69e3b99cf0",
        "storage_key": "property/6767906449167196/019d0220-a05d-7663-94b9-5a69e3b99cf0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/midland/midland-loop-250-h-e-b-717?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=3710171481433835556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "31.9959842",
      "poi_longitude": "-102.1554494",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-699-8201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f330-7322-81c0-aa32659cc4e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f330-7322-81c0-aa32659cc4e2",
        "storage_key": "property/6767906449167196/019d0220-f330-7322-81c0-aa32659cc4e2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdCinHjZ-4YRJAimFk4tfTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5b3d754a-326b-4a7b-a677-0ee2b676ab8d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "200 I-20, Midland, TX 79701, USA",
      "poi_short_description": "Comprehensive department store offering a wide selection of groceries and household goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-a630-7449-bccb-f2d7333dc284.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-a630-7449-bccb-f2d7333dc284",
        "storage_key": "property/6767906449167196/019d0220-a630-7449-bccb-f2d7333dc284.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3645-midland-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3419591414903976075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "31.9746483",
      "poi_longitude": "-102.0708362",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 432-684-3910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32d-761f-b739-9b0cc01cb978",
        "storage_key": "property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvbBNXadi-YYRi7BTKkbUdC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_dad3dd27-42d1-4932-ae73-c7f985ca79aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "4001 Midland Dr, Midland, TX 79707, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-4a16-7348-85a8-eac8a07e7e98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-4a16-7348-85a8-eac8a07e7e98",
        "storage_key": "property/6767906449167196/01a14138-4a16-7348-85a8-eac8a07e7e98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/midland/770",
      "poi_directions_map_url": "https://maps.google.com/?cid=16962703667910056808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.02332",
      "poi_longitude": "-102.1448906",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-699-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32d-761f-b739-9b0cc01cb978",
        "storage_key": "property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJty9dNEHZ-4YRaJv-Gx2hZ-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a188d98e-a5fb-40fe-aa2c-2bd24879cc01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland Park Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "4511 N Midkiff Rd, Midland, TX 79705, USA",
      "poi_short_description": "Casual shopping center offering familiar chain retailers, restaurants & a children's play area.",
      "poi_long_description": "Casual shopping center offering familiar chain retailers, restaurants & a children's play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14135-d3be-743d-9733-b32b0124694c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-d3be-743d-9733-b32b0124694c",
        "storage_key": "property/6767906449167196/01a14135-d3be-743d-9733-b32b0124694c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/midland-park-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=8691727017798498722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-park-mall",
      "poi_latitude": "32.0304055",
      "poi_longitude": "-102.1317351",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-694-1664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32d-761f-b739-9b0cc01cb978",
        "storage_key": "property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJl4w-YTrZ-4YRonmLBKw3n3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_fdc91a16-ba22-452a-bce4-b21ee4840185",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "1500 Tradewinds Blvd, Midland, TX 79706, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-3db3-771d-bec1-ae41ea7527b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-3db3-771d-bec1-ae41ea7527b5",
        "storage_key": "property/6767906449167196/01a14138-3db3-771d-bec1-ae41ea7527b5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/8288-midland-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=8338591742869070241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "31.99467169999999",
      "poi_longitude": "-102.156225",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-699-5933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32d-761f-b739-9b0cc01cb978",
        "storage_key": "property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu-tmI4LZ-4YRoWG3qAKhuHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_6ce73286-6bc8-4774-ae22-972317bc4b9d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Bonham Elementary School",
      "poi_type": "Education",
      "poi_address": "909 Bonham St, Midland, TX 79703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://midlandisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4733188790883108062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonham-elementary-school",
      "poi_latitude": "31.99546969999999",
      "poi_longitude": "-102.1290998",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 432-240-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWcV1gqjZ-4YR3sRytyCqr0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c70aa472-3f45-429f-80aa-75ab0709fdac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Alamo Junior High School",
      "poi_type": "Education",
      "poi_address": "3800 Storey Ave, Midland, TX 79703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-481a-75ba-b9ce-35e4e4a47dee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-481a-75ba-b9ce-35e4e4a47dee",
        "storage_key": "property/6767906449167196/01a14138-481a-75ba-b9ce-35e4e4a47dee.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2737292242894861169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamo-junior-high-school",
      "poi_latitude": "31.9940697",
      "poi_longitude": "-102.1318966",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 432-240-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ9rjZqbZ-4YRcTMuyMrQ_CU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_976c6fd1-8a3c-4627-b596-9862894c94cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Legacy Senior High School",
      "poi_type": "Education",
      "poi_address": "3500 Neely Ave, Midland, TX 79707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-43d1-701b-a9f5-29ec0720cd09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-43d1-701b-a9f5-29ec0720cd09",
        "storage_key": "property/6767906449167196/01a14138-43d1-701b-a9f5-29ec0720cd09.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://lhs.midlandisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18373429739940966379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-senior-high-school",
      "poi_latitude": "32.0118522",
      "poi_longitude": "-102.1291501",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 432-240-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQeEDfhDZ-4YR62_HegCJ-_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9eb22d17-b06f-40e4-952c-33b07e07dc6c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland Montessori School",
      "poi_type": "Education",
      "poi_address": "1011 Austin St, Midland, TX 79703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-42d0-776e-b546-9892a0c8ed06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-42d0-776e-b546-9892a0c8ed06",
        "storage_key": "property/6767906449167196/01a14138-42d0-776e-b546-9892a0c8ed06.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.midlandmontessorischool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=460106198865775957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-montessori-school",
      "poi_latitude": "31.9998177",
      "poi_longitude": "-102.120532",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 432-699-1665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhXN7fQDZ-4YRVY1ZbiagYgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e1ed57b9-6e02-40ac-97b5-25bab3c9d71c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland Christian School",
      "poi_type": "Education",
      "poi_address": "2001 Culver Dr, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-4754-776a-89ec-74ccc329891f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-4754-776a-89ec-74ccc329891f",
        "storage_key": "property/6767906449167196/01a14138-4754-776a-89ec-74ccc329891f.webp",
        "width": 1280,
        "height": 252
      },
      "poi_business_url": "http://www.midlandchristianschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17316216489465216598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-christian-school",
      "poi_latitude": "32.00981",
      "poi_longitude": "-102.1152368",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-694-1661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3yE1v-LY-4YRVv5V5CaPT_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_21538f92-f4a9-4418-9d3a-c8971812810b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland College",
      "poi_type": "Education",
      "poi_address": "3600 N Garfield St, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14135-d476-73ce-99dd-93ab346d6bd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-d476-73ce-99dd-93ab346d6bd9",
        "storage_key": "property/6767906449167196/01a14135-d476-73ce-99dd-93ab346d6bd9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.midland.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12902905061812523829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-college",
      "poi_latitude": "32.0297923",
      "poi_longitude": "-102.1085317",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-685-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl7OGydvY-4YRNdPsi8pTELM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8f602a5c-b146-4743-810c-bdd3166c640a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Pre-K Academy at Midland College",
      "poi_type": "Education",
      "poi_address": "3600 N Garfield St, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.midland.edu/services-resources/main-campus-resources/prek-academy.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=1025721430574146620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pre-k-academy-at-midland-college",
      "poi_latitude": "32.0299808",
      "poi_longitude": "-102.103064",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-685-6809",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkVs4JMDZ-4YRPKTg4zQYPA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_5cb42fe7-903f-42d8-ae5f-fd414af60fd7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Helen L. Greathouse Children's Center",
      "poi_type": "Education",
      "poi_address": "3600 N Garfield St, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8457735079049565778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "helen-l-greathouse-childrens-center",
      "poi_latitude": "32.0287796",
      "poi_longitude": "-102.1048548",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-685-4574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc7OGydvY-4YRUhYcTz7pX3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f500528a-422d-4ac9-80d1-7269dc3018f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Day By Day Learning Center",
      "poi_type": "Education",
      "poi_address": "1016 Andrews Hwy, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-4b3c-776b-b8b6-6192421874eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-4b3c-776b-b8b6-6192421874eb",
        "storage_key": "property/6767906449167196/01a14138-4b3c-776b-b8b6-6192421874eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15584325180657484492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "day-by-day-learning-center",
      "poi_latitude": "32.0029697",
      "poi_longitude": "-102.1118333",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-218-8679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo12oUP_Y-4YRzMJDuS6lRtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_fa88410f-4c07-4c9f-85a2-ca44e8fb439d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Super Kids Early Learning Academy",
      "poi_type": "Education",
      "poi_address": "1703 N Big Spring St, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-4fa4-718e-92a1-e8258b53af50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-4fa4-718e-92a1-e8258b53af50",
        "storage_key": "property/6767906449167196/01a14138-4fa4-718e-92a1-e8258b53af50.webp",
        "width": 1280,
        "height": 1042
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237311357578505910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "super-kids-early-learning-academy",
      "poi_latitude": "32.0143433",
      "poi_longitude": "-102.0790312",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-269-2651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE_A62VTZ-4YRtu5dtVUYcGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_6ede1102-31f5-43d0-a9ad-9e51b12091f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Permian Basin Petroleum Museum",
      "poi_type": "Entertainment",
      "poi_address": "1500 I-20, Midland, TX 79701, USA",
      "poi_short_description": "Interactive exhibits interpret the history of oil, its geology & the industry's modern roots.",
      "poi_long_description": "Interactive exhibits interpret the history of oil, its geology & the industry's modern roots.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14135-dca3-75de-a766-7632b2ac530f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-dca3-75de-a766-7632b2ac530f",
        "storage_key": "property/6767906449167196/01a14135-dca3-75de-a766-7632b2ac530f.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://petroleummuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17173222098646240074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "permian-basin-petroleum-museum",
      "poi_latitude": "31.9720665",
      "poi_longitude": "-102.0851728",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 432-683-4403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f8bf-7529-8402-972790a5a1a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f8bf-7529-8402-972790a5a1a1",
        "storage_key": "property/6767906449167196/019d0220-f8bf-7529-8402-972790a5a1a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLSwNsBHY-4YRSouy1oKKU-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0bf68ad1-2776-4393-8bda-c418db47a820",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Cinergy Midland Tall City",
      "poi_type": "Entertainment",
      "poi_address": "4915 Loop 250 Frontage Rd, Midland, TX 79707, USA",
      "poi_short_description": "Multi-entertainment venue featuring a movie theater, bowling, arcade games, and go-karts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-4f37-70ba-baaf-36c617444b48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-4f37-70ba-baaf-36c617444b48",
        "storage_key": "property/6767906449167196/01a14138-4f37-70ba-baaf-36c617444b48.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://www.cinergy.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing-amarillo",
      "poi_directions_map_url": "https://maps.google.com/?cid=7916785967260067510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinergy-midland-tall-city",
      "poi_latitude": "32.0224146",
      "poi_longitude": "-102.1502212",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-247-8974",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f8c5-71cd-a56c-6bc1c8497c01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f8c5-71cd-a56c-6bc1c8497c01",
        "storage_key": "property/6767906449167196/019d0220-f8c5-71cd-a56c-6bc1c8497c01.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_UK9Rg3Z-4YRtmZVbeQS3m0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_efa434e2-60b1-4853-9d3b-31f0af38873e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Yucca Theatre",
      "poi_type": "Entertainment",
      "poi_address": "208 N Colorado St, Midland, TX 79701, USA",
      "poi_short_description": "Historic performing arts theater featuring the popular annual Summer Mummers production.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-5b4a-7478-b663-2936eec76515.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-5b4a-7478-b663-2936eec76515",
        "storage_key": "property/6767906449167196/01a14138-5b4a-7478-b663-2936eec76515.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mctmidland.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16137008218236140427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yucca-theatre",
      "poi_latitude": "31.9989261",
      "poi_longitude": "-102.0766907",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-570-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-8960-71cf-8c9f-b2ef20da9eff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-8960-71cf-8c9f-b2ef20da9eff",
        "storage_key": "property/6767906449167196/01a14138-8960-71cf-8c9f-b2ef20da9eff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq5Lwu37Y-4YRizuGGXor8t8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_2f8b922a-a695-472f-81d3-7d99873b26a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Wagner Noël Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "1310 Farm to Market 1788, Midland, TX 79707, USA",
      "poi_short_description": "Massive, contemporary performance hall hosting musicians, operas, ballets & headline comedians.",
      "poi_long_description": "Massive, contemporary performance hall hosting musicians, operas, ballets & headline comedians.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-5947-713f-b26f-a2b510a7b7b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-5947-713f-b26f-a2b510a7b7b4",
        "storage_key": "property/6767906449167196/01a14138-5947-713f-b26f-a2b510a7b7b4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.wagnernoel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7435613550878986471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wagner-nol-performing-arts-center",
      "poi_latitude": "31.970134400000003",
      "poi_longitude": "-102.2467799",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-552-4430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-8960-71cf-8c9f-b2ef20da9eff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-8960-71cf-8c9f-b2ef20da9eff",
        "storage_key": "property/6767906449167196/01a14138-8960-71cf-8c9f-b2ef20da9eff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7csYSO7C-4YR5xA5AyGbMGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_1f79456c-0b0d-45c5-acda-b41e0b6e46d7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Sibley Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1307 E Wadley Ave, Midland, TX 79705, USA",
      "poi_short_description": "Nature center with programs, tours & exhibits highlighting the wildlife & flora of the region.",
      "poi_long_description": "Nature center with programs, tours & exhibits highlighting the wildlife & flora of the region.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-5a22-77f9-85f3-e97520e912f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-5a22-77f9-85f3-e97520e912f9",
        "storage_key": "property/6767906449167196/01a14138-5a22-77f9-85f3-e97520e912f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sibleynaturecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4221596657924795195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sibley-nature-center",
      "poi_latitude": "32.032959999999996",
      "poi_longitude": "-102.0703552",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-684-6827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-213ab71664f6",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fr0U6fY-4YRO2uVHMsfljo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_286354dd-2111-47e7-82af-2b57ec321e8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Watersong Wild Space",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2201 S Midland Dr, Midland, TX 79703, USA",
      "poi_short_description": "Urban playa lake habitat with hiking trails & wildlife spotting from viewing platforms & blinds.",
      "poi_long_description": "Urban playa lake habitat with hiking trails & wildlife spotting from viewing platforms & blinds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-cbf7-700c-8da4-6da2e10955c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-cbf7-700c-8da4-6da2e10955c1",
        "storage_key": "property/6767906449167196/019d0220-cbf7-700c-8da4-6da2e10955c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.watersong.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17678376154120734455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "watersong-wild-space",
      "poi_latitude": "31.96169",
      "poi_longitude": "-102.123738",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-853-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-213ab71664f6",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqd3oZNHZ-4YR90YauHI1VvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_663b8240-244c-48a6-be7a-fa8f3f49c2fe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Green Acres Mini Golf",
      "poi_type": "Entertainment",
      "poi_address": "2905 E Hwy 80, Midland, TX 79706, USA",
      "poi_short_description": "Family-friendly miniature golf course featuring go-karts, an arcade, and yard games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-ba80-72a3-b90d-c7fc8cd7b48b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-ba80-72a3-b90d-c7fc8cd7b48b",
        "storage_key": "property/6767906449167196/019d0220-ba80-72a3-b90d-c7fc8cd7b48b.webp",
        "width": 960,
        "height": 502
      },
      "poi_business_url": "http://greenacresmidland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4820631129680995153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "green-acres-mini-golf",
      "poi_latitude": "32.0168319",
      "poi_longitude": "-102.0361156",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 432-618-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWn22U9i-YYRUWPTvXhS5kI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "miniature_golf_course"
    },
    {
      "id": "custom_f71d0920-395b-44c2-93de-3f671c13e451",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland Army Air Field Museum Hangar",
      "poi_type": "Entertainment",
      "poi_address": "9600 Wright Dr, Midland, TX 79706, USA",
      "poi_short_description": "Educational military aviation museum featuring historical aircraft and exhibits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-5d33-74c8-bb9d-c4e838be7e4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-5d33-74c8-bb9d-c4e838be7e4b",
        "storage_key": "property/6767906449167196/01a14138-5d33-74c8-bb9d-c4e838be7e4b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.highskywing.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12508760768526204053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-army-air-field-museum-hangar",
      "poi_latitude": "31.9418417",
      "poi_longitude": "-102.2146406",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 432-254-6182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f8bf-7529-8402-972790a5a1a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f8bf-7529-8402-972790a5a1a1",
        "storage_key": "property/6767906449167196/019d0220-f8bf-7529-8402-972790a5a1a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgQaX0n7Q-4YRlbxYDKULmK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4536a722-74f3-4be1-b9ef-134dca4721c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland County Horseshoe",
      "poi_type": "Entertainment",
      "poi_address": "2514 Arena Trl, Midland, TX 79701, USA",
      "poi_short_description": "Versatile event venue hosting diverse gatherings, concerts, and exhibitions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-58f7-750a-b2d9-30e097311110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-58f7-750a-b2d9-30e097311110",
        "storage_key": "property/6767906449167196/01a14138-58f7-750a-b2d9-30e097311110.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://midlandhorseshoe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5612639400662611446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-county-horseshoe",
      "poi_latitude": "31.9715017",
      "poi_longitude": "-102.0950046",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-682-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14136-1158-700c-89ac-e75c8d93225f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14136-1158-700c-89ac-e75c8d93225f",
        "storage_key": "property/6767906449167196/01a14136-1158-700c-89ac-e75c8d93225f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ43HEZw3Z-4YR9jXbQMwZ5E0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_6816eb6a-91e1-4de5-b8cd-2c3d5071e28b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Astound Broadband Stadium",
      "poi_type": "Entertainment",
      "poi_address": "801 N Loop 250 W, Midland, TX 79703, USA",
      "poi_short_description": "Modern stadium hosting high school football games with a well-maintained turf field.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14135-da66-70c9-9b28-5a14c022d673.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-da66-70c9-9b28-5a14c022d673",
        "storage_key": "property/6767906449167196/01a14135-da66-70c9-9b28-5a14c022d673.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9618717631948349240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "astound-broadband-stadium",
      "poi_latitude": "31.989252499999996",
      "poi_longitude": "-102.153937",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f8c3-730d-8054-964ad133431f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f8c3-730d-8054-964ad133431f",
        "storage_key": "property/6767906449167196/019d0220-f8c3-730d-8054-964ad133431f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNRNGypzZ-4YROF8RX7mMfIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_f403b39c-c161-41ba-afcb-a7f1a2e333de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland Memorial Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "400 Rosalind Redfern Grover Pkwy, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14135-ed7c-77db-b06d-3fa5d1117cef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-ed7c-77db-b06d-3fa5d1117cef",
        "storage_key": "property/6767906449167196/01a14135-ed7c-77db-b06d-3fa5d1117cef.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.midlandhealth.org/?utm_source=google&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=75874490978375239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-memorial-hospital",
      "poi_latitude": "31.996637899999996",
      "poi_longitude": "-102.0996046",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 432-221-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe84-726c-af79-ed53a57706dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe84-726c-af79-ed53a57706dd",
        "storage_key": "property/6767906449167196/019d0220-fe84-726c-af79-ed53a57706dd.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4USlpV7Y-4YRR5ZHknKPDQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ae6dc6f9-d8d8-4757-a73a-984811b72c68",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "SignatureCare Emergency Center : Emergency Room",
      "poi_type": "Health and Wellness",
      "poi_address": "5409 W Wadley Ave, Midland, TX 79707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-5fa9-7309-980e-7ceeded8445f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-5fa9-7309-980e-7ceeded8445f",
        "storage_key": "property/6767906449167196/01a14138-5fa9-7309-980e-7ceeded8445f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ercare24.com/midland/?y_source=1_MTE2Mjg4MjYtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=8235343072132141647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "signaturecare-emergency-center--emergency-room",
      "poi_latitude": "32.01096",
      "poi_longitude": "-102.15965",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-699-2601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe84-726c-af79-ed53a57706dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe84-726c-af79-ed53a57706dd",
        "storage_key": "property/6767906449167196/019d0220-fe84-726c-af79-ed53a57706dd.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDy2eyGPZ-4YRTxLpMeTQSXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_e12c812e-9740-43ab-b73c-c84c26740da1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "WesTex Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "6301 Andrews Hwy, Midland, TX 79706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-c06b-735c-9c9f-5c7cde12556d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-c06b-735c-9c9f-5c7cde12556d",
        "storage_key": "property/6767906449167196/019d0220-c06b-735c-9c9f-5c7cde12556d.webp",
        "width": 1264,
        "height": 720
      },
      "poi_business_url": "https://westexurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16936332149709622173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westex-urgent-care",
      "poi_latitude": "31.993729",
      "poi_longitude": "-102.1675677",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-505-4146",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRTZihXZ-4YRnUt4jVvwCes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_bb85e47a-d6d4-47fc-9e5e-cabb8d91335e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 Andrews Hwy, Midland, TX 79703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-318c-73c0-bb8d-c1c12e68f625.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-318c-73c0-bb8d-c1c12e68f625",
        "storage_key": "property/6767906449167196/01a14138-318c-73c0-bb8d-c1c12e68f625.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/midland-tx-pharmacies/4401-andrews-hwy-midland-tx-79703/storeid=10643?WT.mc_id=LS_GOOGLE_RX_10643",
      "poi_directions_map_url": "https://maps.google.com/?cid=13343000705093946505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.001193799999996",
      "poi_longitude": "-102.1375902",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 432-689-0936",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-250289bca231.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-250289bca231",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-250289bca231.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1_cLpAvZ-4YRiUzpcHLcK7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_7225efd6-d4b4-4a7b-a87c-509e1242369a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5407 Andrews Hwy, Midland, TX 79706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-664a-76df-929a-474bb484c3d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-664a-76df-929a-474bb484c3d5",
        "storage_key": "property/6767906449167196/01a14138-664a-76df-929a-474bb484c3d5.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=15018448649350820685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "31.995624799999995",
      "poi_longitude": "-102.155413",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 432-699-2331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-250289bca231.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-250289bca231",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-250289bca231.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4xgeoLZ-4YRTTMAtnk_bNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_f74da619-b73d-4541-86f7-35809ed92513",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 N Midkiff Rd, Midland, TX 79701, USA",
      "poi_short_description": "Welcoming fitness center offering affordable memberships and a wide variety of exercise equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-c735-717b-a187-05deca4ce115.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-c735-717b-a187-05deca4ce115",
        "storage_key": "property/6767906449167196/019d0220-c735-717b-a187-05deca4ce115.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/midland-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1617383553482956190&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.0014621",
      "poi_longitude": "-102.1182505",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 432-689-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_kSHADZ-4YRnh3pysUZchY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fa6e023e-3f9c-416c-854b-57cb809de26c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Power House Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "1028 Andrews Hwy, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-66a6-777c-ae72-8ff3c9a621bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-66a6-777c-ae72-8ff3c9a621bf",
        "storage_key": "property/6767906449167196/01a14138-66a6-777c-ae72-8ff3c9a621bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://powerhousemidland.carrd.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10287967501281122001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "power-house-gym",
      "poi_latitude": "32.0023666",
      "poi_longitude": "-102.113549",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 432-242-1614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr0GQDwDZ-4YR0dafNu8zxo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d85cf1c8-fad3-4a0e-8e02-31264d299a99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Renewed Strength Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3200 Mockingbird Ln bldg 3, Midland, TX 79705, USA",
      "poi_short_description": "Welcoming fitness center offering CrossFit, bouldering, and cycle classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-64ab-746c-9789-6447e2c5359d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-64ab-746c-9789-6447e2c5359d",
        "storage_key": "property/6767906449167196/01a14138-64ab-746c-9789-6447e2c5359d.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.renewedstrengthfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2064993214927893493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renewed-strength-fitness",
      "poi_latitude": "32.049737500000006",
      "poi_longitude": "-102.1320795",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-901-8551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxT67xkvY-4YR9XNeX2NUqBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_826a553a-0cfb-4024-aa0d-150d2807bba0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland Yoga Works",
      "poi_type": "Health and Wellness",
      "poi_address": "4610 N Garfield St Suite B11, Midland, TX 79705, USA",
      "poi_short_description": "Welcoming yoga studio offering a wide variety of classes including aerial, yin, and breathwork.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-cba9-71d9-8683-57f3350d7350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-cba9-71d9-8683-57f3350d7350",
        "storage_key": "property/6767906449167196/019d0220-cba9-71d9-8683-57f3350d7350.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.midlandyogaworks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15987936150688414603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-yoga-works",
      "poi_latitude": "32.040319",
      "poi_longitude": "-102.1115822",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-559-8935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMc5oTN3Y-4YRi7toqTiP4N0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_742e35b5-7161-4aa2-8bad-b653c5b9a289",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Grafa Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Grafa Park, Midland, TX 79705, USA",
      "poi_short_description": "Park with big trees and a walking trail, as well as a playground or slides.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-7075-763b-bef6-f279606a7cfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-7075-763b-bef6-f279606a7cfd",
        "storage_key": "property/6767906449167196/01a14138-7075-763b-bef6-f279606a7cfd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9080562310837750770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grafa-park",
      "poi_latitude": "32.009146799999996",
      "poi_longitude": "-102.1204076",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-213ab71664f6",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Wk7GNTZ-4YR8stIkk-jBH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e844d01f-ae1f-4811-bbe1-4a4469906782",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Hogan's Run Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 E Wadley Ave, Midland, TX 79705, USA",
      "poi_short_description": "Spacious dog park featuring divided play areas and agility equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-6af6-71a9-9e6e-df94833f5ca6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-6af6-71a9-9e6e-df94833f5ca6",
        "storage_key": "property/6767906449167196/01a14138-6af6-71a9-9e6e-df94833f5ca6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.midlandtexas.gov/Facilities/Facility/Details/Hogans-Dog-Run-3",
      "poi_directions_map_url": "https://maps.google.com/?cid=11567904854149024865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hogans-run-dog-park",
      "poi_latitude": "32.0366438",
      "poi_longitude": "-102.0723513",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-685-7356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-213ab71664f6",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0VdYgZi-YYRYcwR6yx0iaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_ad7d5ce5-21ef-47e4-a8d1-f3249b1ffe7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Windlands Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1001 W Dengar Ave, Midland, TX 79705, USA",
      "poi_short_description": "55-acre community park with 13 soccer & 4 baseball fields, jogging path, pavilions & picnic tables.",
      "poi_long_description": "55-acre community park with 13 soccer & 4 baseball fields, jogging path, pavilions & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-6a95-70af-a16f-5cc5e8119b7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-6a95-70af-a16f-5cc5e8119b7d",
        "storage_key": "property/6767906449167196/01a14138-6a95-70af-a16f-5cc5e8119b7d.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.midlandtexas.gov/Facilities/Facility/Details/Windlands-Park-52?mobile=ON",
      "poi_directions_map_url": "https://maps.google.com/?cid=10347702257385947792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windlands-park",
      "poi_latitude": "32.0254154",
      "poi_longitude": "-102.0953492",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-685-7356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-213ab71664f6",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_6ZaDcDY-4YRkEL_7GBsmo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_a70f9c40-ddae-4b1f-80f1-837495902f20",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Beal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5200 W Wall St, Midland, TX 79703, USA",
      "poi_short_description": "Sizable area featuring a playground, sports facilities, an off-leash dog park & a fishing pond.",
      "poi_long_description": "Sizable area featuring a playground, sports facilities, an off-leash dog park & a fishing pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14135-f15a-74fb-9eca-cf8a503b4249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-f15a-74fb-9eca-cf8a503b4249",
        "storage_key": "property/6767906449167196/01a14135-f15a-74fb-9eca-cf8a503b4249.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.midlandtexas.gov/Facilities/Facility/Details/Beal-Park-2",
      "poi_directions_map_url": "https://maps.google.com/?cid=7756242855263869794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beal-park",
      "poi_latitude": "31.965182",
      "poi_longitude": "-102.1385535",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-685-7356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-213ab71664f6",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwD9QMLZ-4YRYhuqU8i1o2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_b66f4f59-9f19-42aa-9491-40488eb8b417",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "C.J. Kelly Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5500 League Dr, Midland, TX 79707, USA",
      "poi_short_description": "Outdoor recreation area with baseball diamonds & sports fields, plus a pond & play equipment.",
      "poi_long_description": "Outdoor recreation area with baseball diamonds & sports fields, plus a pond & play equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-719c-746b-a053-28115b8d76e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-719c-746b-a053-28115b8d76e1",
        "storage_key": "property/6767906449167196/01a14138-719c-746b-a053-28115b8d76e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.midlandtexas.gov/Facilities/Facility/Details/CJ-Kelly-Park-30",
      "poi_directions_map_url": "https://maps.google.com/?cid=15780737712741271971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cj-kelly-park",
      "poi_latitude": "32.015972999999995",
      "poi_longitude": "-102.1619655",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 432-685-7356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-213ab71664f6",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3UX9J2DZ-4YRo8mN_VZxANs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_7799027f-46b4-4eac-a147-d4cfdb53e8f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Lancaster Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Lancaster Park, Midland, TX 79703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-7181-764e-8945-63c0dd4d53f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-7181-764e-8945-63c0dd4d53f6",
        "storage_key": "property/6767906449167196/01a14138-7181-764e-8945-63c0dd4d53f6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7118481483065157784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lancaster-park",
      "poi_latitude": "31.99490909999999",
      "poi_longitude": "-102.124268",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-213ab71664f6",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKR0mToPZ-4YRmGhLijHtyWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6f0f7066-2b1c-41d3-90cb-654413d08358",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Trinity Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Trinity Park, Midland, TX 79707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8985422638686375100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-park",
      "poi_latitude": "32.0226908",
      "poi_longitude": "-102.1376785",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-213ab71664f6",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5jGmz7Z-4YRvIynd0iisnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_539aac4b-6b5a-492b-ad43-301e101aae0f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Tumbleweed Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "802 Ventura Ave, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-771b-714f-a03b-ac8ace1fd09b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-771b-714f-a03b-ac8ace1fd09b",
        "storage_key": "property/6767906449167196/01a14138-771b-714f-a03b-ac8ace1fd09b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1384420432223217612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tumbleweed-park",
      "poi_latitude": "32.0216482",
      "poi_longitude": "-102.0969592",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-fe7c-75db-81dd-213ab71664f6",
        "storage_key": "property/6767906449167196/019d0220-fe7c-75db-81dd-213ab71664f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_eZy9jZ-4YRzCd1UgxzNhM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d6a6a945-64f0-4861-bc8b-8831a2690f98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland International Air & Space Port",
      "poi_type": "Transportation & Transit",
      "poi_address": "9506 La Force Blvd, Midland, TX 79706, USA",
      "poi_short_description": "Airport with a terminal housing the 1911 Pliska Aeroplane, the first airplane built in Texas.",
      "poi_long_description": "Airport with a terminal housing the 1911 Pliska Aeroplane, the first airplane built in Texas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-d899-7708-9af9-bf3e54e86d16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-d899-7708-9af9-bf3e54e86d16",
        "storage_key": "property/6767906449167196/019d0220-d899-7708-9af9-bf3e54e86d16.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.flymaf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9536195868847421991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-international-air--space-port",
      "poi_latitude": "31.9417386",
      "poi_longitude": "-102.2047497",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 432-560-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0221-01ec-7729-a32f-a43e8f57ddb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-01ec-7729-a32f-a43e8f57ddb4",
        "storage_key": "property/6767906449167196/019d0221-01ec-7729-a32f-a43e8f57ddb4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJTQSBGYDQ-4YRJ7oyJ55fV4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_f93874c8-b0da-4a86-9344-f3b036419865",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland Airpark",
      "poi_type": "Transportation & Transit",
      "poi_address": "901 Veterans Airpark Ln, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-da31-72b9-a672-5424d99e690e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-da31-72b9-a672-5424d99e690e",
        "storage_key": "property/6767906449167196/019d0220-da31-72b9-a672-5424d99e690e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flymaf.com/149/Midland-Executive-Airpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=9810408844524569748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-airpark",
      "poi_latitude": "32.0331878",
      "poi_longitude": "-102.0970535",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-685-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0221-01ec-7729-a32f-a43e8f57ddb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-01ec-7729-a32f-a43e8f57ddb4",
        "storage_key": "property/6767906449167196/019d0221-01ec-7729-a32f-a43e8f57ddb4.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZ4T9cXY-4YRlMQ8x92SJYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_5ef83c2c-c366-4fb3-aeec-154867d1572b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "MOUTD/EZ-Rider",
      "poi_type": "Transportation & Transit",
      "poi_address": "10300 Younger Rd, Midland, TX 79711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-db83-7679-a928-a248fe6233bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0220-db83-7679-a928-a248fe6233bb",
        "storage_key": "property/6767906449167196/019d0220-db83-7679-a928-a248fe6233bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ez-rider.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10338501385586336029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moutdez-rider",
      "poi_latitude": "31.925958199999997",
      "poi_longitude": "-102.2185827",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 432-561-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAwhWl_rR-4YRHeHBBTy8eY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_b604c5a5-1bcb-452c-a82b-66904f1e9fff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Love's Travel Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "5200 Cholla Rd, Midland, TX 79706, USA",
      "poi_short_description": "Truck stop offering diesel fuel, convenience supplies, and various food options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-77d7-7452-91f7-f7474da7d539.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-77d7-7452-91f7-f7474da7d539",
        "storage_key": "property/6767906449167196/01a14138-77d7-7452-91f7-f7474da7d539.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/locations/tx/midland/loves-travel-stop-midland-623",
      "poi_directions_map_url": "https://maps.google.com/?cid=9212357356841470162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loves-travel-stop",
      "poi_latitude": "31.947301999999997",
      "poi_longitude": "-102.1407268",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-699-2374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32d-761f-b739-9b0cc01cb978",
        "storage_key": "property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPZz2bV7X-4YR0gh-9jTe2H8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "custom_3aa225a9-64d7-4749-9606-f3d390b3d0a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Flying J Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3302 Garden City Hwy, Midland, TX 79706, USA",
      "poi_short_description": "Full-service truck stop offering fuel and various food options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-7c3e-7604-83e3-213253f46bfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-7c3e-7604-83e3-213253f46bfa",
        "storage_key": "property/6767906449167196/01a14138-7c3e-7604-83e3-213253f46bfa.webp",
        "width": 1280,
        "height": 891
      },
      "poi_business_url": "https://locations.pilotflyingj.com/us/tx/midland/3302-garden-city-hwy",
      "poi_directions_map_url": "https://maps.google.com/?cid=9457224658088145562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flying-j-travel-center",
      "poi_latitude": "31.9806242",
      "poi_longitude": "-102.0337402",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 432-685-1296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32d-761f-b739-9b0cc01cb978",
        "storage_key": "property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSewVQNxi-YYRmrJoUrjPPoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "custom_3c0e486f-7e5f-45de-aaba-9f3754296692",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Pilot Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "2810 Rankin Hwy, Midland, TX 79706, USA",
      "poi_short_description": "Travel center offering fuel, pizza, and traveler amenities including showers and parking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-7c3e-7604-83e3-213253f46bfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-7c3e-7604-83e3-213253f46bfa",
        "storage_key": "property/6767906449167196/01a14138-7c3e-7604-83e3-213253f46bfa.webp",
        "width": 1280,
        "height": 891
      },
      "poi_business_url": "https://locations.pilotflyingj.com/us/tx/midland/2810-rankin-hwy",
      "poi_directions_map_url": "https://maps.google.com/?cid=13095741723400015717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilot-travel-center",
      "poi_latitude": "31.9683194",
      "poi_longitude": "-102.0735113",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 432-687-1658",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32d-761f-b739-9b0cc01cb978",
        "storage_key": "property/6767906449167196/019d0220-f32d-761f-b739-9b0cc01cb978.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRVGXWxLZ-4YRZQ-FlbZrvbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "custom_e9d2ad5b-b1d7-462f-ba7e-fd6129e669b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Greyhound: Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "4001 Farm to Market 1788, Midland, TX 79706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-7840-76cf-baa2-05042058ce9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-7840-76cf-baa2-05042058ce9a",
        "storage_key": "property/6767906449167196/01a14138-7840-76cf-baa2-05042058ce9a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/midland-tx/midland-stripes?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=14698242193621888103&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-stop",
      "poi_latitude": "31.915414",
      "poi_longitude": "-102.2162898",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmXgd4LjO-4YRZ6x9hWal-ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_9e9e1ead-728a-47cc-8e7c-2b3a61fbe941",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "DV Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "901 Veterans Airpark Ln, Midland, TX 79705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-77de-719b-a0ad-9f326360feec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-77de-719b-a0ad-9f326360feec",
        "storage_key": "property/6767906449167196/01a14138-77de-719b-a0ad-9f326360feec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dvaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6539463644075400584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dv-aviation",
      "poi_latitude": "32.0332939",
      "poi_longitude": "-102.097004",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-685-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi3u43LnY-4YRiB2yZonXwFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aircraft_rental_service"
    },
    {
      "id": "custom_49a5bc32-edf4-44b3-818b-a65209a4e176",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Diamondback Energy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 W Texas Ave #100, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-7e49-752c-ada5-f4a3067cf2f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-7e49-752c-ada5-f4a3067cf2f9",
        "storage_key": "property/6767906449167196/01a14138-7e49-752c-ada5-f4a3067cf2f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.diamondbackenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6887214597652199409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "diamondback-energy",
      "poi_latitude": "31.998738599999996",
      "poi_longitude": "-102.0799771",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 432-221-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNSwf9XzY-4YR8bfxwC9NlF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ca29a0ac-5ff2-424a-994c-3f5e071e0afb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "ConocoPhillips",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 W Illinois Ave, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-8272-755c-803f-590349c109fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-8272-755c-803f-590349c109fb",
        "storage_key": "property/6767906449167196/01a14138-8272-755c-803f-590349c109fb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.conocophillips.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18149832283709337339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conocophillips",
      "poi_latitude": "31.999892",
      "poi_longitude": "-102.0809883",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-683-7443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlbJt93zY-4YR-25p00wo4fs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_36c72457-159e-439b-b101-81968820317d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "SLB Midland HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7220 I-20 Frontage, Midland, TX 79706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-7ed0-7641-b90d-b22d647f59fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-7ed0-7641-b90d-b22d647f59fc",
        "storage_key": "property/6767906449167196/01a14138-7ed0-7641-b90d-b22d647f59fc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.slb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16617103578552329806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slb-midland-hq",
      "poi_latitude": "31.93689539999999",
      "poi_longitude": "-102.1688784",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 432-742-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21M4D67Q-4YRTuZ726nPm-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ae0cf1b6-58df-45ad-93c3-9d1e7515bb40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Oxy - Midland",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Gehrig Dr, Midland, TX 79706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14136-0927-739f-ba02-b3db797eb137.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14136-0927-739f-ba02-b3db797eb137",
        "storage_key": "property/6767906449167196/01a14136-0927-739f-ba02-b3db797eb137.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.oxy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14418470198711973448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxy---midland",
      "poi_latitude": "31.9938792",
      "poi_longitude": "-102.16289650000002",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 432-684-2994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f329-712b-9870-3d7b3cde4038",
        "storage_key": "property/6767906449167196/019d0220-f329-712b-9870-3d7b3cde4038.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRpkgbzY-4YRSHbI3kCyGMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_72839fd2-bc90-4b2d-a686-2a6b76b3f931",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "The University of Texas Permian Basin",
      "poi_type": "Education",
      "poi_address": "4901 E University Blvd, Odessa, TX 79762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-7eea-70bb-b31b-d073a9f0ee1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-7eea-70bb-b31b-d073a9f0ee1c",
        "storage_key": "property/6767906449167196/01a14138-7eea-70bb-b31b-d073a9f0ee1c.webp",
        "width": 1280,
        "height": 532
      },
      "poi_business_url": "http://www.utpb.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16037060805297192125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-permian-basin",
      "poi_latitude": "31.8876067",
      "poi_longitude": "-102.3230046",
      "poi_miles_from_property": "16.1",
      "poi_walking_minutes": "5 hours 54 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 432-552-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs0RSpufO-4YRvTwUndUVj94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_988bf02d-9712-45a3-899e-ce2690396844",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "City of Midland City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 N Loraine St, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-8018-76ac-a457-6572307f57dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-8018-76ac-a457-6572307f57dd",
        "storage_key": "property/6767906449167196/01a14138-8018-76ac-a457-6572307f57dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.midlandtexas.gov/Facilities/Facility/Details/City-Hall-64",
      "poi_directions_map_url": "https://maps.google.com/?cid=7075327628908885444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-midland-city-hall",
      "poi_latitude": "32.000009399999996",
      "poi_longitude": "-102.0754433",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 432-685-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0221-0245-70f8-b4c6-1123d6230bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-0245-70f8-b4c6-1123d6230bf7",
        "storage_key": "property/6767906449167196/019d0221-0245-70f8-b4c6-1123d6230bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSnP5H7Y-4YRxPWe5v2cMGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_84cbfe31-5b4a-4536-ad57-92582f5baa2b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 N Loraine St, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-7fef-722b-bfd5-df1ef2cb49fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-7fef-722b-bfd5-df1ef2cb49fb",
        "storage_key": "property/6767906449167196/01a14138-7fef-722b-bfd5-df1ef2cb49fb.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "https://www.co.midland.tx.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9890265255750974068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-county-courthouse",
      "poi_latitude": "32.0022537",
      "poi_longitude": "-102.0753094",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 432-742-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0221-0245-70f8-b4c6-1123d6230bf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0221-0245-70f8-b4c6-1123d6230bf7",
        "storage_key": "property/6767906449167196/019d0221-0245-70f8-b4c6-1123d6230bf7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJETUQtX7Y-4YRdLpsZ9lHQYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_5d8d5ac0-76b4-4d63-a17a-6f4be8f65e12",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "custom",
      "poi_name": "Midland Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "615 W Missouri Ave, Midland, TX 79701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/01a14138-8392-753a-b025-4b0ba51e9f7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-8392-753a-b025-4b0ba51e9f7f",
        "storage_key": "property/6767906449167196/01a14138-8392-753a-b025-4b0ba51e9f7f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://midlandisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9588241872557365515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midland-independent-school-district",
      "poi_latitude": "31.9961089",
      "poi_longitude": "-102.0814243",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 432-240-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0220-f32c-7204-baa0-a1115d721b5b",
        "storage_key": "property/6767906449167196/019d0220-f32c-7204-baa0-a1115d721b5b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8aF0E3vY-4YRC9lOsi5HEIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8e1a0bbe28339e5b7463da4a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c2b394c11548d480aaed896a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c3be08c374818f13ac9229ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fd3d82d6baa981350b11cb47",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_13f65196188974b4312d7728",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_73d3d895b8be9ac944085256",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "ec_6677ea20dd75c3e920a5c51e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167196/019d0221-69ed-73e9-aa37-07cd220109bf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with fireplace and mirror, and a glimpse of the kitchen.",
        "public_id": "019d0221-69ed-73e9-aa37-07cd220109bf",
        "storage_key": "property/6767906449167196/019d0221-69ed-73e9-aa37-07cd220109bf.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "Medium 1 Bedroom",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=94PjEGzXoEm"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-e214-7209-8ff8-7698d29d43c8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Cypress Pointe Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "apartments-with-pool-midland-tx",
      "search_query": "apartments with pool in Midland TX",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Midland, TX",
      "h2_subtitle": "Discover your ideal home with a pool in Midland, TX at Cypress Pointe. Enjoy community amenities that suit every lifestyle.",
      "page_copy": "Cypress Pointe offers stunning apartments with pool in Midland, TX, perfect for anyone seeking a life of leisure and convenience. Located in the heart of Superior neighborhood, our community ensures residents have everything they need at their fingertips. Relax and unwind by our shimmering pool, the perfect escape for sunny Texas days.\n\nOur apartments feature central AC and heating to keep you comfortable year-round. Select two-bedroom homes boast washer/dryer hookups, adding to the convenience of living here. Kids will love the onsite playground, and everyone can enjoy the luxury of a private patio or balcony in select units. With round-the-clock emergency maintenance, Cypress Pointe ensures peace of mind for all residents. Discover stylish living with a pool in Midland today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Apartments with Pool in Midland, TX",
      "seo_description": "Explore Cypress Pointe, apartments with pool in Midland, TX. Enjoy top amenities and convenient living in the Superior neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "central-ac-heating-apartments-79703",
      "search_query": "central AC and heating apartments 79703",
      "category": "Amenity",
      "h1_title": "Central AC and Heating Apartments 79703",
      "h2_subtitle": "Experience year-round comfort in 79703 with central AC and heating at Cypress Pointe. Enjoy modern living in our newly upgraded apartments.",
      "page_copy": "At Cypress Pointe, we offer central AC and heating apartments in the 79703 area, ensuring that you enjoy the perfect indoor climate no matter the season. Nestled in the vibrant community of Midland, our homes are designed with your comfort in mind, featuring amenities that cater to modern living needs.\n\nIn addition to climate control, select homes boast washer/dryer hookups, adding efficiency to your daily routine. Residents enjoy access to a variety of community amenities, including a playground for younger family members and the option of a private patio or balcony. With our dependable emergency maintenance team available 24/7, Cypress Pointe guarantees a stress-free lifestyle. Discover the comfort and convenience of living in our centrally heated and cooled apartments today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Central AC & Heating Apartments 79703",
      "seo_description": "Find central AC and heating apartments in the 79703 area at Cypress Pointe. Enjoy comfort with modern amenities in Midland's Superior neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "apartments-with-playground-superior-neighborhood",
      "search_query": "apartments with playground in Superior neighborhood",
      "category": "Amenity",
      "h1_title": "Apartments with Playground in Superior",
      "h2_subtitle": "Cypress Pointe offers family-friendly apartments with a playground in the Superior neighborhood. Enjoy a community perfect for all ages.",
      "page_copy": "Welcome to Cypress Pointe, where you can find apartments with a playground right in the heart of the Superior neighborhood. Our community is designed for families who value convenience, fun, and comfort in a vibrant Midland setting. Children will delight in the safe and well-equipped playground just a short stroll from your front door.\n\nOur homes boast central AC and heating, ensuring you're cozy throughout the year. Select two-bedroom options come with washer/dryer hookups for added convenience. Residents enjoy access to additional perks, such as patios or balconies in select units and 24/7 emergency maintenance support. Cypress Pointe truly offers family living with amenities that make life easier and more enjoyable. Explore the ideal lifestyle for your family today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Apartments with Playground in Superior",
      "seo_description": "Discover Cypress Pointe's family-friendly apartments with a playground in the Superior neighborhood. Ideal for an active family lifestyle in Midland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "walk-in-closets-apartments-midland-county",
      "search_query": "walk-in closets apartments Midland County",
      "category": "Amenity",
      "h1_title": "Walk-in Closets Apartments Midland County",
      "h2_subtitle": "Find spacious apartments with walk-in closets in Midland County. Enhance your lifestyle with generous storage at Cypress Pointe.",
      "page_copy": "Discover spacious living at Cypress Pointe, offering apartments with walk-in closets in Midland County. Our community combines convenience and style, providing ample storage solutions in each residence. Located within the vibrant area of Midland, our apartments ensure easy access to all local conveniences.\n\nBeyond expansive closets, each home is equipped with central AC and heating, ensuring comfort throughout the year. Selected two-bedroom homes feature the added benefit of washer/dryer hookups. Residents can enjoy a variety of community amenities, including a playground and select units with private patios or balconies. Our 24-hour emergency maintenance team assures peace of mind, making Cypress Pointe a desirable place to call home. Experience the perfect balance of functionality and style today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Walk-in Closets Apartments Midland County",
      "seo_description": "Explore walk-in closet apartments at Cypress Pointe in Midland County. Discover convenient living with ample storage and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "emergency-maintenance-apartments-midland-tx",
      "search_query": "emergency maintenance apartments Midland TX",
      "category": "Amenity",
      "h1_title": "Emergency Maintenance Apartments Midland TX",
      "h2_subtitle": "Cypress Pointe provides reliable emergency maintenance in Midland, TX. Enjoy peace of mind with our 24/7 service in a welcoming community.",
      "page_copy": "At Cypress Pointe, we understand the importance of reliable emergency maintenance, which is why we offer apartments in Midland, TX with round-the-clock support. Our dedicated maintenance team is on call 24/7, ensuring that any issues in your apartment are addressed promptly. This commitment to service adds an extra layer of comfort and security for our residents.\n\nLocated in a vibrant area of Midland, our homes provide modern conveniences such as central AC and heating, and select units feature washer/dryer hookups. Families will appreciate our community playground, and select homes extend outdoor living options with a patio or balcony. Experience worry-free living while enjoying all the amenities our community has to offer at Cypress Pointe.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Emergency Maintenance Apartments Midland TX",
      "seo_description": "Ensure peace of mind with emergency maintenance apartments in Midland, TX at Cypress Pointe. Enjoy 24/7 service and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "studio-apartments-midland-tx",
      "search_query": "studio apartments in Midland TX",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Midland TX",
      "h2_subtitle": "Explore convenient studio apartments in Midland, TX at Cypress Pointe. Enjoy modern living in a vibrant neighborhood.",
      "page_copy": "Discover the perfect blend of style and efficiency at Cypress Pointe, where our studio apartments in Midland, TX offer a modern living environment. Designed to maximize space and functionality, our studios are ideal for those seeking a comfortable, yet compact living experience in the heart of Midland.\n\nResidents enjoy the benefits of central AC and heating, ensuring year-round comfort. The community features a playground, enhancing our family-friendly atmosphere. Select units offer private patios or balconies, perfect for relaxing after a busy day. At Cypress Pointe, we prioritize convenience with 24/7 emergency maintenance services, making sure you always feel at home. Experience the advantages of studio living with us today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Studio Apartments in Midland TX",
      "seo_description": "Find modern studio apartments at Cypress Pointe in Midland, TX. Enjoy efficient living with great amenities and excellent community features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "one-bedroom-floorplans-midland-county",
      "search_query": "one bedroom floorplans in Midland County",
      "category": "Floorplan",
      "h1_title": "One Bedroom Floorplans in Midland County",
      "h2_subtitle": "Explore spacious one bedroom floorplans in Midland County at Cypress Pointe. Enjoy comfortable living with modern amenities in our vibrant community.",
      "page_copy": "Cypress Pointe offers spacious one bedroom floorplans in Midland County, perfect for those seeking a blend of comfort and style. Each apartment is designed with thoughtful layouts that maximize living space while providing all the modern amenities needed for a convenient lifestyle.\n\nOur community offers central AC and heating to ensure comfort throughout the seasons. Select homes feature private patios or balconies, expanding your living area outdoors. With additional amenities like a community playground and 24/7 emergency maintenance, Cypress Pointe caters to every need. Located in a thriving area of Midland, you'll enjoy easy access to local dining, shopping, and entertainment. Discover a one-bedroom home that meets your needs at Cypress Pointe.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: One Bedroom Floorplans Midland County",
      "seo_description": "Discover spacious one bedroom floorplans in Midland County at Cypress Pointe. Enjoy modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-superior-midland-tx",
      "search_query": "two bedroom apartments near Superior",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Superior",
      "h2_subtitle": "Discover comfortable two bedroom apartments near Superior at Cypress Pointe. Experience convenient living in a community-focused environment.",
      "page_copy": "For those seeking two bedroom apartments near Superior, Cypress Pointe offers the perfect solution. Our spacious two-bedroom layouts provide the ideal blend of comfort and functionality, tailored for families or roommates looking for ample living space. \n\nSelect two bedroom homes come equipped with washer/dryer hookups, simplifying household chores. Enjoy the convenience of central AC and heating, ensuring a comfortable environment year-round. Our community promotes an active lifestyle with features like a playground and emergency maintenance services available 24/7. Located in Midland, we're close to local attractions, dining, and shopping, making Cypress Pointe a prime location for those wanting proximity to the thriving Superior neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Two Bedroom Apartments Near Superior",
      "seo_description": "Find spacious two bedroom apartments near Superior at Cypress Pointe and enjoy modern living with exceptional community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "apartments-near-midland-college-tx",
      "search_query": "apartments near Midland College TX",
      "category": "School",
      "h1_title": "Apartments Near Midland College TX",
      "h2_subtitle": "Discover convenient apartments near Midland College, TX at Cypress Pointe. Enjoy a comfortable lifestyle close to campus and local amenities.",
      "page_copy": "Cypress Pointe offers the ideal location for students and faculty seeking apartments near Midland College, TX. Just a short drive from campus, our community combines convenience with modern living, making it perfect for those juggling academic and professional commitments.\n\nOur apartments feature central AC and heating, ensuring a pleasant environment throughout the year. Residents benefit from amenities like a community playground and select units with private patios or balconies. 24/7 emergency maintenance provides peace of mind, ensuring that any issues are addressed promptly. Whether you're focusing on studies or enjoying leisure time, Cypress Pointe makes it easy to balance work and play in Midland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Apartments Near Midland College TX",
      "seo_description": "Located near Midland College, TX, Cypress Pointe offers modern apartments with great amenities and a convenient lifestyle perfect for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "cypress-pointe-apartments-midland-county-near-college",
      "search_query": "Cypress Pointe apartments in Midland County close to Midland College",
      "category": "School",
      "h1_title": "Cypress Pointe Apartments Near Midland College",
      "h2_subtitle": "Explore Cypress Pointe apartments in Midland County, conveniently located close to Midland College. Discover an enriched lifestyle with thoughtful amenities.",
      "page_copy": "Cypress Pointe offers exceptional apartments in Midland County, strategically located close to Midland College, providing a perfect home for students and faculty alike. With our central location, commuting to campus is quick and simple, allowing more time for study or leisure.\n\nOur community features modern amenities, including central AC and heating, ensuring comfort throughout the year. Residents enjoy access to a playground and the convenience of 24/7 emergency maintenance services. Select two-bedroom units come with the added benefit of washer/dryer hookups, designed to streamline daily life. Living at Cypress Pointe keeps you close to educational pursuits and the lifestyle benefits of Midland’s thriving community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Close to Midland College Apartments",
      "seo_description": "Find Cypress Pointe apartments in Midland County, conveniently near Midland College, offering modern amenities and a prime location for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "apartments-near-midland-memorial-hospital",
      "search_query": "apartments near Midland Memorial Hospital Midland",
      "category": "Hospital",
      "h1_title": "Apartments Near Midland Memorial Hospital",
      "h2_subtitle": "Discover your new home at Cypress Pointe, offering convenient apartments near Midland Memorial Hospital in Midland. Enjoy comfortable, modern living.",
      "page_copy": "Cypress Pointe is the perfect place for those seeking apartments near Midland Memorial Hospital in Midland. Our location provides easy access for hospital staff, patients, and visitors, ensuring a stress-free commute.\n\nResidents enjoy amenities designed to enhance comfort and convenience, such as central AC and heating. Our community includes a playground for recreation and select homes equipped with washer/dryer hookups. With 24/7 emergency maintenance, you can focus on your career or recovery with peace of mind. Enjoy a seamless blend of work and relaxation at Cypress Pointe, just moments from Midland Memorial Hospital.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Apartments Near Midland Memorial Hospital",
      "seo_description": "Explore Cypress Pointe for comfortable living near Midland Memorial Hospital. Enjoy modern amenities and an ideal location in Midland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "apartments-near-summit-center-park-midland-tx",
      "search_query": "apartments near Summit Center Park Midland TX",
      "category": "Park",
      "h1_title": "Apartments Near Summit Center Park Midland TX",
      "h2_subtitle": "Discover Cypress Pointe, offering apartments near Summit Center Park, Midland TX. Enjoy easy access to outdoor activities and modern living amenities.",
      "page_copy": "For unparalleled access to outdoor recreation, discover Cypress Pointe, ideally situated with apartments near Summit Center Park in Midland, TX. Our community grants you easy access to one of Midland's favorite spots, making weekend outings and daily exercise routines a breeze.\n\nAt Cypress Pointe, our amenities are designed to complement your lifestyle, featuring central AC and heating for year-round comfort. Families will appreciate the on-site playground, and select units offer washer/dryer hookups for added convenience. With 24-hour emergency maintenance, you can enjoy peace of mind while living close to both nature and city conveniences.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Apartments by Summit Center Park",
      "seo_description": "Live close to Summit Center Park at Cypress Pointe in Midland, TX, offering modern amenities and a prime location for outdoor enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "cypress-pointe-near-dennis-the-menace-park",
      "search_query": "Cypress Pointe apartments close to Dennis the Menace Park Superior",
      "category": "Park",
      "h1_title": "Cypress Pointe Near Dennis the Menace Park",
      "h2_subtitle": "Enjoy living at Cypress Pointe, conveniently close to Dennis the Menace Park in Superior. Discover a vibrant community with great amenities.",
      "page_copy": "Cypress Pointe Apartments bring you close to the excitement of Dennis the Menace Park in Superior, making it an ideal location for families and park enthusiasts alike. Located in a neighborhood brimming with charm, Cypress Pointe offers a gateway to adventure just steps from your door.\n\nOur community features central AC and heating, ensuring comfort no matter the season, along with a well-maintained playground on-site for added family fun. Select homes come equipped with washer/dryer hookups. Prompt emergency maintenance services add an extra layer of convenience, allowing you to enjoy life at Cypress Pointe, just a stroll away from the fun and excitement of Dennis the Menace Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Close to Dennis the Menace Park",
      "seo_description": "Find home at Cypress Pointe, near Dennis the Menace Park in Superior, offering modern amenities and close proximity to Midland's recreational spots.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "apartments-near-midland-international-air-space-port",
      "search_query": "apartments near midland international air & space port",
      "category": "Transit",
      "h1_title": "Apartments Near Midland International Air & Space Port",
      "h2_subtitle": "Cypress Pointe offers premium apartments near Midland International Air & Space Port, perfect for frequent flyers and airport staff seeking convenience.",
      "page_copy": "Cypress Pointe is ideally located for those in need of apartments near Midland International Air & Space Port. Just a short drive away, our community provides a convenient and comfortable living option for frequent travelers and airport employees.\n\nResidents enjoy modern amenities such as central AC and heating, ensuring a pleasant climate year-round. Select two-bedroom units feature washer/dryer hookups, enhancing the convenience of your home life. With a dedicated playground and round-the-clock emergency maintenance, Cypress Pointe is an excellent choice for balancing work, travel, and relaxation while living near the airport.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Near Midland International Airport",
      "seo_description": "Discover Cypress Pointe, offering convenient living near Midland International Air & Space Port with modern amenities and quick airport access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167196",
      "source": "generator",
      "page_item_url": "apartments-close-to-midland-airpark",
      "search_query": "apartments close to midland airpark",
      "category": "Transit",
      "h1_title": "Apartments Close to Midland Airpark",
      "h2_subtitle": "Cypress Pointe offers comfortable apartments close to Midland Airpark, ideal for aviation enthusiasts and professionals.",
      "page_copy": "Cypress Pointe features comfortable living spaces conveniently situated close to Midland Airpark, perfect for those who value easy airport access. Whether you're part of the aviation community or simply enjoy spending time at the airpark, our location is just right.\n\nEnjoy modern comforts, including central AC and heating in every home. Some two-bedroom units also provide in-home washer/dryer hookups. Our community includes a playground for leisure activities and ensures peace of mind with 24/7 emergency maintenance services. Cypress Pointe combines the attractiveness of a great location with a welcoming environment, making it an ideal choice near Midland Airpark.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Pointe: Close to Midland Airpark",
      "seo_description": "Discover Cypress Pointe apartments, conveniently close to Midland Airpark, featuring modern amenities and easy airport access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309503645"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4322183263"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "61e0a722-122f-4940-a6d1-f15807524378"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/77826130-a9ba-4da9-a0f3-70f364e511b2/app.js?property=77826130-a9ba-4da9-a0f3-70f364e511b2&propertyName=Cypress+Pointe&channelUuid=c248f94e-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47569576752"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InRyMENaT2dpUFU1VjExaERWUy9iNnc9PSIsInZhbHVlIjoiNzdzbVpISmF2UFFETnBYeDRVWnNEZz09IiwibWFjIjoiOTJjNzM5MGJjMTIzY2MzYjIyMGY3ZDZjNjI1OWFhNThkZTVkMzJkODEwN2ZmYmZkNTYxMGMwODU1MmU0OTFhNiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309503645",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4322183263",
  "custom_rollout_phase": "Phase 8",
  "custom_rentgrata_token": "61e0a722-122f-4940-a6d1-f15807524378",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/77826130-a9ba-4da9-a0f3-70f364e511b2/app.js?property=77826130-a9ba-4da9-a0f3-70f364e511b2&propertyName=Cypress+Pointe&channelUuid=c248f94e-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47569576752",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InRyMENaT2dpUFU1VjExaERWUy9iNnc9PSIsInZhbHVlIjoiNzdzbVpISmF2UFFETnBYeDRVWnNEZz09IiwibWFjIjoiOTJjNzM5MGJjMTIzY2MzYjIyMGY3ZDZjNjI1OWFhNThkZTVkMzJkODEwN2ZmYmZkNTYxMGMwODU1MmU0OTFhNiJ9",
  "custom_audioeye_site_id": "bc2887c6-f057-464e-900e-e2a11919f371",
  "custom_audioeye_site_hash": "6af18fd78f143531632cd60eede109e6"
};

export const generatedAt = '2026-11-02T18:10:22.562Z';
